import { j as ee } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import * as Ye from "react";
import Ue, { useRef as oe, useCallback as re, useEffect as ce, useMemo as jt, useLayoutEffect as lr, useReducer as dr, cloneElement as fr, Component as pr } from "react";
import { P as hr, d as gr, c as mr } from "../../chunks/Popover.IWkkIIzd.js";
import { c as Se } from "../../chunks/index.CxSWpsOB.js";
import { g as vr } from "../../chunks/_commonjsHelpers.DaMA6jEr.js";
import { _ as qe } from "../../chunks/Combination.r_wXKfB6.js";
import { I as _r } from "../../chunks/Input.D9O4R5sO.js";
import { F as yr } from "../../chunks/Check20.CqJjuR__.js";
import { F as Ir } from "../../chunks/Search20.DPh0h8Ck.js";
import { B as Er } from "../../chunks/Button.Ccj-dDdM.js";
import { F as br } from "../../chunks/ChevronDown20.NQYj4T82.js";
import { useFormContext as wr } from "react-hook-form";
import { d as Cr, e as xr, f as Or, b as Kt, g as Dr } from "../../chunks/Form.LdCd9gH2.js";
function ve(e, t) {
  if (e == null) return {};
  var r = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.indexOf(o) !== -1) continue;
    r[o] = e[o];
  }
  return r;
}
function Y() {
  return Y = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var o in r) ({}).hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, Y.apply(null, arguments);
}
function lt(e, t) {
  return lt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, lt(e, t);
}
function Sr(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, lt(e, t);
}
var dt = { exports: {} }, ke = { exports: {} }, U = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wt;
function Ar() {
  if (Wt) return U;
  Wt = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, n = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, a = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, O = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, c = e ? Symbol.for("react.scope") : 60119;
  function h(f) {
    if (typeof f == "object" && f !== null) {
      var M = f.$$typeof;
      switch (M) {
        case t:
          switch (f = f.type, f) {
            case a:
            case l:
            case o:
            case n:
            case i:
            case g:
              return f;
            default:
              switch (f = f && f.$$typeof, f) {
                case u:
                case d:
                case O:
                case y:
                case s:
                  return f;
                default:
                  return M;
              }
          }
        case r:
          return M;
      }
    }
  }
  function p(f) {
    return h(f) === l;
  }
  return U.AsyncMode = a, U.ConcurrentMode = l, U.ContextConsumer = u, U.ContextProvider = s, U.Element = t, U.ForwardRef = d, U.Fragment = o, U.Lazy = O, U.Memo = y, U.Portal = r, U.Profiler = n, U.StrictMode = i, U.Suspense = g, U.isAsyncMode = function(f) {
    return p(f) || h(f) === a;
  }, U.isConcurrentMode = p, U.isContextConsumer = function(f) {
    return h(f) === u;
  }, U.isContextProvider = function(f) {
    return h(f) === s;
  }, U.isElement = function(f) {
    return typeof f == "object" && f !== null && f.$$typeof === t;
  }, U.isForwardRef = function(f) {
    return h(f) === d;
  }, U.isFragment = function(f) {
    return h(f) === o;
  }, U.isLazy = function(f) {
    return h(f) === O;
  }, U.isMemo = function(f) {
    return h(f) === y;
  }, U.isPortal = function(f) {
    return h(f) === r;
  }, U.isProfiler = function(f) {
    return h(f) === n;
  }, U.isStrictMode = function(f) {
    return h(f) === i;
  }, U.isSuspense = function(f) {
    return h(f) === g;
  }, U.isValidElementType = function(f) {
    return typeof f == "string" || typeof f == "function" || f === o || f === l || f === n || f === i || f === g || f === v || typeof f == "object" && f !== null && (f.$$typeof === O || f.$$typeof === y || f.$$typeof === s || f.$$typeof === u || f.$$typeof === d || f.$$typeof === m || f.$$typeof === F || f.$$typeof === c || f.$$typeof === E);
  }, U.typeOf = h, U;
}
var q = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yt;
function Mr() {
  return Yt || (Yt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, n = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, a = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, O = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, c = e ? Symbol.for("react.scope") : 60119;
    function h(w) {
      return typeof w == "string" || typeof w == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      w === o || w === l || w === n || w === i || w === g || w === v || typeof w == "object" && w !== null && (w.$$typeof === O || w.$$typeof === y || w.$$typeof === s || w.$$typeof === u || w.$$typeof === d || w.$$typeof === m || w.$$typeof === F || w.$$typeof === c || w.$$typeof === E);
    }
    function p(w) {
      if (typeof w == "object" && w !== null) {
        var te = w.$$typeof;
        switch (te) {
          case t:
            var A = w.type;
            switch (A) {
              case a:
              case l:
              case o:
              case n:
              case i:
              case g:
                return A;
              default:
                var fe = A && A.$$typeof;
                switch (fe) {
                  case u:
                  case d:
                  case O:
                  case y:
                  case s:
                    return fe;
                  default:
                    return te;
                }
            }
          case r:
            return te;
        }
      }
    }
    var f = a, M = l, V = u, R = s, L = t, H = d, j = o, W = O, J = y, T = r, Q = n, Z = i, ie = g, se = !1;
    function le(w) {
      return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), _(w) || p(w) === a;
    }
    function _(w) {
      return p(w) === l;
    }
    function D(w) {
      return p(w) === u;
    }
    function x(w) {
      return p(w) === s;
    }
    function C(w) {
      return typeof w == "object" && w !== null && w.$$typeof === t;
    }
    function b(w) {
      return p(w) === d;
    }
    function S(w) {
      return p(w) === o;
    }
    function P(w) {
      return p(w) === O;
    }
    function N(w) {
      return p(w) === y;
    }
    function k(w) {
      return p(w) === r;
    }
    function K(w) {
      return p(w) === n;
    }
    function $(w) {
      return p(w) === i;
    }
    function X(w) {
      return p(w) === g;
    }
    q.AsyncMode = f, q.ConcurrentMode = M, q.ContextConsumer = V, q.ContextProvider = R, q.Element = L, q.ForwardRef = H, q.Fragment = j, q.Lazy = W, q.Memo = J, q.Portal = T, q.Profiler = Q, q.StrictMode = Z, q.Suspense = ie, q.isAsyncMode = le, q.isConcurrentMode = _, q.isContextConsumer = D, q.isContextProvider = x, q.isElement = C, q.isForwardRef = b, q.isFragment = S, q.isLazy = P, q.isMemo = N, q.isPortal = k, q.isProfiler = K, q.isStrictMode = $, q.isSuspense = X, q.isValidElementType = h, q.typeOf = p;
  }()), q;
}
var Ut;
function mn() {
  return Ut || (Ut = 1, process.env.NODE_ENV === "production" ? ke.exports = Ar() : ke.exports = Mr()), ke.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var rt, qt;
function Rr() {
  if (qt) return rt;
  qt = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function o(n) {
    if (n == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(n);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var n = new String("abc");
      if (n[5] = "de", Object.getOwnPropertyNames(n)[0] === "5")
        return !1;
      for (var s = {}, u = 0; u < 10; u++)
        s["_" + String.fromCharCode(u)] = u;
      var a = Object.getOwnPropertyNames(s).map(function(d) {
        return s[d];
      });
      if (a.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        l[d] = d;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return rt = i() ? Object.assign : function(n, s) {
    for (var u, a = o(n), l, d = 1; d < arguments.length; d++) {
      u = Object(arguments[d]);
      for (var g in u)
        t.call(u, g) && (a[g] = u[g]);
      if (e) {
        l = e(u);
        for (var v = 0; v < l.length; v++)
          r.call(u, l[v]) && (a[l[v]] = u[l[v]]);
      }
    }
    return a;
  }, rt;
}
var ot, zt;
function bt() {
  if (zt) return ot;
  zt = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ot = e, ot;
}
var it, Gt;
function vn() {
  return Gt || (Gt = 1, it = Function.call.bind(Object.prototype.hasOwnProperty)), it;
}
var st, Xt;
function Tr() {
  if (Xt) return st;
  Xt = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = bt(), r = {}, o = vn();
    e = function(n) {
      var s = "Warning: " + n;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(n, s, u, a, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in n)
        if (o(n, d)) {
          var g;
          try {
            if (typeof n[d] != "function") {
              var v = Error(
                (a || "React class") + ": " + u + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw v.name = "Invariant Violation", v;
            }
            g = n[d](s, d, a, u, null, t);
          } catch (O) {
            g = O;
          }
          if (g && !(g instanceof Error) && e(
            (a || "React class") + ": type specification of " + u + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof g + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), g instanceof Error && !(g.message in r)) {
            r[g.message] = !0;
            var y = l ? l() : "";
            e(
              "Failed " + u + " type: " + g.message + (y ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, st = i, st;
}
var ut, Jt;
function Pr() {
  if (Jt) return ut;
  Jt = 1;
  var e = mn(), t = Rr(), r = bt(), o = vn(), i = Tr(), n = function() {
  };
  process.env.NODE_ENV !== "production" && (n = function(u) {
    var a = "Warning: " + u;
    typeof console < "u" && console.error(a);
    try {
      throw new Error(a);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return ut = function(u, a) {
    var l = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function g(_) {
      var D = _ && (l && _[l] || _[d]);
      if (typeof D == "function")
        return D;
    }
    var v = "<<anonymous>>", y = {
      array: F("array"),
      bigint: F("bigint"),
      bool: F("boolean"),
      func: F("function"),
      number: F("number"),
      object: F("object"),
      string: F("string"),
      symbol: F("symbol"),
      any: c(),
      arrayOf: h,
      element: p(),
      elementType: f(),
      instanceOf: M,
      node: H(),
      objectOf: R,
      oneOf: V,
      oneOfType: L,
      shape: W,
      exact: J
    };
    function O(_, D) {
      return _ === D ? _ !== 0 || 1 / _ === 1 / D : _ !== _ && D !== D;
    }
    function E(_, D) {
      this.message = _, this.data = D && typeof D == "object" ? D : {}, this.stack = "";
    }
    E.prototype = Error.prototype;
    function m(_) {
      if (process.env.NODE_ENV !== "production")
        var D = {}, x = 0;
      function C(S, P, N, k, K, $, X) {
        if (k = k || v, $ = $ || N, X !== r) {
          if (a) {
            var w = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw w.name = "Invariant Violation", w;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var te = k + ":" + N;
            !D[te] && // Avoid spamming the console because they are often not actionable except for lib authors
            x < 3 && (n(
              "You are manually calling a React.PropTypes validation function for the `" + $ + "` prop on `" + k + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), D[te] = !0, x++);
          }
        }
        return P[N] == null ? S ? P[N] === null ? new E("The " + K + " `" + $ + "` is marked as required " + ("in `" + k + "`, but its value is `null`.")) : new E("The " + K + " `" + $ + "` is marked as required in " + ("`" + k + "`, but its value is `undefined`.")) : null : _(P, N, k, K, $);
      }
      var b = C.bind(null, !1);
      return b.isRequired = C.bind(null, !0), b;
    }
    function F(_) {
      function D(x, C, b, S, P, N) {
        var k = x[C], K = Z(k);
        if (K !== _) {
          var $ = ie(k);
          return new E(
            "Invalid " + S + " `" + P + "` of type " + ("`" + $ + "` supplied to `" + b + "`, expected ") + ("`" + _ + "`."),
            { expectedType: _ }
          );
        }
        return null;
      }
      return m(D);
    }
    function c() {
      return m(s);
    }
    function h(_) {
      function D(x, C, b, S, P) {
        if (typeof _ != "function")
          return new E("Property `" + P + "` of component `" + b + "` has invalid PropType notation inside arrayOf.");
        var N = x[C];
        if (!Array.isArray(N)) {
          var k = Z(N);
          return new E("Invalid " + S + " `" + P + "` of type " + ("`" + k + "` supplied to `" + b + "`, expected an array."));
        }
        for (var K = 0; K < N.length; K++) {
          var $ = _(N, K, b, S, P + "[" + K + "]", r);
          if ($ instanceof Error)
            return $;
        }
        return null;
      }
      return m(D);
    }
    function p() {
      function _(D, x, C, b, S) {
        var P = D[x];
        if (!u(P)) {
          var N = Z(P);
          return new E("Invalid " + b + " `" + S + "` of type " + ("`" + N + "` supplied to `" + C + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(_);
    }
    function f() {
      function _(D, x, C, b, S) {
        var P = D[x];
        if (!e.isValidElementType(P)) {
          var N = Z(P);
          return new E("Invalid " + b + " `" + S + "` of type " + ("`" + N + "` supplied to `" + C + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(_);
    }
    function M(_) {
      function D(x, C, b, S, P) {
        if (!(x[C] instanceof _)) {
          var N = _.name || v, k = le(x[C]);
          return new E("Invalid " + S + " `" + P + "` of type " + ("`" + k + "` supplied to `" + b + "`, expected ") + ("instance of `" + N + "`."));
        }
        return null;
      }
      return m(D);
    }
    function V(_) {
      if (!Array.isArray(_))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? n(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : n("Invalid argument supplied to oneOf, expected an array.")), s;
      function D(x, C, b, S, P) {
        for (var N = x[C], k = 0; k < _.length; k++)
          if (O(N, _[k]))
            return null;
        var K = JSON.stringify(_, function(X, w) {
          var te = ie(w);
          return te === "symbol" ? String(w) : w;
        });
        return new E("Invalid " + S + " `" + P + "` of value `" + String(N) + "` " + ("supplied to `" + b + "`, expected one of " + K + "."));
      }
      return m(D);
    }
    function R(_) {
      function D(x, C, b, S, P) {
        if (typeof _ != "function")
          return new E("Property `" + P + "` of component `" + b + "` has invalid PropType notation inside objectOf.");
        var N = x[C], k = Z(N);
        if (k !== "object")
          return new E("Invalid " + S + " `" + P + "` of type " + ("`" + k + "` supplied to `" + b + "`, expected an object."));
        for (var K in N)
          if (o(N, K)) {
            var $ = _(N, K, b, S, P + "." + K, r);
            if ($ instanceof Error)
              return $;
          }
        return null;
      }
      return m(D);
    }
    function L(_) {
      if (!Array.isArray(_))
        return process.env.NODE_ENV !== "production" && n("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var D = 0; D < _.length; D++) {
        var x = _[D];
        if (typeof x != "function")
          return n(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + se(x) + " at index " + D + "."
          ), s;
      }
      function C(b, S, P, N, k) {
        for (var K = [], $ = 0; $ < _.length; $++) {
          var X = _[$], w = X(b, S, P, N, k, r);
          if (w == null)
            return null;
          w.data && o(w.data, "expectedType") && K.push(w.data.expectedType);
        }
        var te = K.length > 0 ? ", expected one of type [" + K.join(", ") + "]" : "";
        return new E("Invalid " + N + " `" + k + "` supplied to " + ("`" + P + "`" + te + "."));
      }
      return m(C);
    }
    function H() {
      function _(D, x, C, b, S) {
        return T(D[x]) ? null : new E("Invalid " + b + " `" + S + "` supplied to " + ("`" + C + "`, expected a ReactNode."));
      }
      return m(_);
    }
    function j(_, D, x, C, b) {
      return new E(
        (_ || "React class") + ": " + D + " type `" + x + "." + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + b + "`."
      );
    }
    function W(_) {
      function D(x, C, b, S, P) {
        var N = x[C], k = Z(N);
        if (k !== "object")
          return new E("Invalid " + S + " `" + P + "` of type `" + k + "` " + ("supplied to `" + b + "`, expected `object`."));
        for (var K in _) {
          var $ = _[K];
          if (typeof $ != "function")
            return j(b, S, P, K, ie($));
          var X = $(N, K, b, S, P + "." + K, r);
          if (X)
            return X;
        }
        return null;
      }
      return m(D);
    }
    function J(_) {
      function D(x, C, b, S, P) {
        var N = x[C], k = Z(N);
        if (k !== "object")
          return new E("Invalid " + S + " `" + P + "` of type `" + k + "` " + ("supplied to `" + b + "`, expected `object`."));
        var K = t({}, x[C], _);
        for (var $ in K) {
          var X = _[$];
          if (o(_, $) && typeof X != "function")
            return j(b, S, P, $, ie(X));
          if (!X)
            return new E(
              "Invalid " + S + " `" + P + "` key `" + $ + "` supplied to `" + b + "`.\nBad object: " + JSON.stringify(x[C], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(_), null, "  ")
            );
          var w = X(N, $, b, S, P + "." + $, r);
          if (w)
            return w;
        }
        return null;
      }
      return m(D);
    }
    function T(_) {
      switch (typeof _) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !_;
        case "object":
          if (Array.isArray(_))
            return _.every(T);
          if (_ === null || u(_))
            return !0;
          var D = g(_);
          if (D) {
            var x = D.call(_), C;
            if (D !== _.entries) {
              for (; !(C = x.next()).done; )
                if (!T(C.value))
                  return !1;
            } else
              for (; !(C = x.next()).done; ) {
                var b = C.value;
                if (b && !T(b[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Q(_, D) {
      return _ === "symbol" ? !0 : D ? D["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && D instanceof Symbol : !1;
    }
    function Z(_) {
      var D = typeof _;
      return Array.isArray(_) ? "array" : _ instanceof RegExp ? "object" : Q(D, _) ? "symbol" : D;
    }
    function ie(_) {
      if (typeof _ > "u" || _ === null)
        return "" + _;
      var D = Z(_);
      if (D === "object") {
        if (_ instanceof Date)
          return "date";
        if (_ instanceof RegExp)
          return "regexp";
      }
      return D;
    }
    function se(_) {
      var D = ie(_);
      switch (D) {
        case "array":
        case "object":
          return "an " + D;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + D;
        default:
          return D;
      }
    }
    function le(_) {
      return !_.constructor || !_.constructor.name ? v : _.constructor.name;
    }
    return y.checkPropTypes = i, y.resetWarningCache = i.resetWarningCache, y.PropTypes = y, y;
  }, ut;
}
var at, Qt;
function Nr() {
  if (Qt) return at;
  Qt = 1;
  var e = bt();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, at = function() {
    function o(s, u, a, l, d, g) {
      if (g !== e) {
        var v = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw v.name = "Invariant Violation", v;
      }
    }
    o.isRequired = o;
    function i() {
      return o;
    }
    var n = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: i,
      element: o,
      elementType: o,
      instanceOf: i,
      node: o,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return n.PropTypes = n, n;
  }, at;
}
if (process.env.NODE_ENV !== "production") {
  var Vr = mn(), Fr = !0;
  dt.exports = Pr()(Vr.isElement, Fr);
} else
  dt.exports = Nr()();
var kr = dt.exports;
const I = /* @__PURE__ */ vr(kr);
var ft = { exports: {} }, z = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zt;
function $r() {
  if (Zt) return z;
  Zt = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), n = Symbol.for("react.provider"), s = Symbol.for("react.context"), u = Symbol.for("react.server_context"), a = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), O;
  O = Symbol.for("react.module.reference");
  function E(m) {
    if (typeof m == "object" && m !== null) {
      var F = m.$$typeof;
      switch (F) {
        case e:
          switch (m = m.type, m) {
            case r:
            case i:
            case o:
            case l:
            case d:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case u:
                case s:
                case a:
                case v:
                case g:
                case n:
                  return m;
                default:
                  return F;
              }
          }
        case t:
          return F;
      }
    }
  }
  return z.ContextConsumer = s, z.ContextProvider = n, z.Element = e, z.ForwardRef = a, z.Fragment = r, z.Lazy = v, z.Memo = g, z.Portal = t, z.Profiler = i, z.StrictMode = o, z.Suspense = l, z.SuspenseList = d, z.isAsyncMode = function() {
    return !1;
  }, z.isConcurrentMode = function() {
    return !1;
  }, z.isContextConsumer = function(m) {
    return E(m) === s;
  }, z.isContextProvider = function(m) {
    return E(m) === n;
  }, z.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, z.isForwardRef = function(m) {
    return E(m) === a;
  }, z.isFragment = function(m) {
    return E(m) === r;
  }, z.isLazy = function(m) {
    return E(m) === v;
  }, z.isMemo = function(m) {
    return E(m) === g;
  }, z.isPortal = function(m) {
    return E(m) === t;
  }, z.isProfiler = function(m) {
    return E(m) === i;
  }, z.isStrictMode = function(m) {
    return E(m) === o;
  }, z.isSuspense = function(m) {
    return E(m) === l;
  }, z.isSuspenseList = function(m) {
    return E(m) === d;
  }, z.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === r || m === i || m === o || m === l || m === d || m === y || typeof m == "object" && m !== null && (m.$$typeof === v || m.$$typeof === g || m.$$typeof === n || m.$$typeof === s || m.$$typeof === a || m.$$typeof === O || m.getModuleId !== void 0);
  }, z.typeOf = E, z;
}
var G = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var en;
function Br() {
  return en || (en = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), n = Symbol.for("react.provider"), s = Symbol.for("react.context"), u = Symbol.for("react.server_context"), a = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), O = !1, E = !1, m = !1, F = !1, c = !1, h;
    h = Symbol.for("react.module.reference");
    function p(A) {
      return !!(typeof A == "string" || typeof A == "function" || A === r || A === i || c || A === o || A === l || A === d || F || A === y || O || E || m || typeof A == "object" && A !== null && (A.$$typeof === v || A.$$typeof === g || A.$$typeof === n || A.$$typeof === s || A.$$typeof === a || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      A.$$typeof === h || A.getModuleId !== void 0));
    }
    function f(A) {
      if (typeof A == "object" && A !== null) {
        var fe = A.$$typeof;
        switch (fe) {
          case e:
            var pe = A.type;
            switch (pe) {
              case r:
              case i:
              case o:
              case l:
              case d:
                return pe;
              default:
                var we = pe && pe.$$typeof;
                switch (we) {
                  case u:
                  case s:
                  case a:
                  case v:
                  case g:
                  case n:
                    return we;
                  default:
                    return fe;
                }
            }
          case t:
            return fe;
        }
      }
    }
    var M = s, V = n, R = e, L = a, H = r, j = v, W = g, J = t, T = i, Q = o, Z = l, ie = d, se = !1, le = !1;
    function _(A) {
      return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function D(A) {
      return le || (le = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function x(A) {
      return f(A) === s;
    }
    function C(A) {
      return f(A) === n;
    }
    function b(A) {
      return typeof A == "object" && A !== null && A.$$typeof === e;
    }
    function S(A) {
      return f(A) === a;
    }
    function P(A) {
      return f(A) === r;
    }
    function N(A) {
      return f(A) === v;
    }
    function k(A) {
      return f(A) === g;
    }
    function K(A) {
      return f(A) === t;
    }
    function $(A) {
      return f(A) === i;
    }
    function X(A) {
      return f(A) === o;
    }
    function w(A) {
      return f(A) === l;
    }
    function te(A) {
      return f(A) === d;
    }
    G.ContextConsumer = M, G.ContextProvider = V, G.Element = R, G.ForwardRef = L, G.Fragment = H, G.Lazy = j, G.Memo = W, G.Portal = J, G.Profiler = T, G.StrictMode = Q, G.Suspense = Z, G.SuspenseList = ie, G.isAsyncMode = _, G.isConcurrentMode = D, G.isContextConsumer = x, G.isContextProvider = C, G.isElement = b, G.isForwardRef = S, G.isFragment = P, G.isLazy = N, G.isMemo = k, G.isPortal = K, G.isProfiler = $, G.isStrictMode = X, G.isSuspense = w, G.isSuspenseList = te, G.isValidElementType = p, G.typeOf = f;
  }()), G;
}
process.env.NODE_ENV === "production" ? ft.exports = $r() : ft.exports = Br();
var tn = ft.exports;
const nn = (e) => typeof e == "object" && e != null && e.nodeType === 1, rn = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", $e = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const r = getComputedStyle(e, null);
    return rn(r.overflowY, t) || rn(r.overflowX, t) || ((o) => {
      const i = ((n) => {
        if (!n.ownerDocument || !n.ownerDocument.defaultView) return null;
        try {
          return n.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(o);
      return !!i && (i.clientHeight < o.scrollHeight || i.clientWidth < o.scrollWidth);
    })(e);
  }
  return !1;
}, Be = (e, t, r, o, i, n, s, u) => n < e && s > t || n > e && s < t ? 0 : n <= e && u <= r || s >= t && u >= r ? n - e - o : s > t && u < r || n < e && u > r ? s - t + i : 0, Hr = (e) => {
  const t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
}, Lr = (e, t) => {
  var r, o, i, n;
  if (typeof document > "u") return [];
  const { inline: s, boundary: u, skipOverflowHiddenElements: a } = t, l = typeof u == "function" ? u : (J) => J !== u;
  if (!nn(e)) throw new TypeError("Invalid target");
  const d = document.scrollingElement || document.documentElement, g = [];
  let v = e;
  for (; nn(v) && l(v); ) {
    if (v = Hr(v), v === d) {
      g.push(v);
      break;
    }
    v != null && v === document.body && $e(v) && !$e(document.documentElement) || v != null && $e(v, a) && g.push(v);
  }
  const y = (o = (r = window.visualViewport) == null ? void 0 : r.width) != null ? o : innerWidth, O = (n = (i = window.visualViewport) == null ? void 0 : i.height) != null ? n : innerHeight, { scrollX: E, scrollY: m } = window, { height: F, width: c, top: h, right: p, bottom: f, left: M } = e.getBoundingClientRect(), { top: V, right: R, left: L } = ((J) => {
    const T = window.getComputedStyle(J);
    return { top: parseFloat(T.scrollMarginTop) || 0, right: parseFloat(T.scrollMarginRight) || 0, bottom: parseFloat(T.scrollMarginBottom) || 0, left: parseFloat(T.scrollMarginLeft) || 0 };
  })(e);
  let H = h - V, j = s === "center" ? M + c / 2 - L + R : s === "end" ? p + R : M - L;
  const W = [];
  for (let J = 0; J < g.length; J++) {
    const T = g[J], { height: Q, width: Z, top: ie, right: se, bottom: le, left: _ } = T.getBoundingClientRect();
    if (h >= 0 && M >= 0 && f <= O && p <= y && (T === d && !$e(T) || h >= ie && f <= le && M >= _ && p <= se)) return W;
    const D = getComputedStyle(T), x = parseInt(D.borderLeftWidth, 10), C = parseInt(D.borderTopWidth, 10), b = parseInt(D.borderRightWidth, 10), S = parseInt(D.borderBottomWidth, 10);
    let P = 0, N = 0;
    const k = "offsetWidth" in T ? T.offsetWidth - T.clientWidth - x - b : 0, K = "offsetHeight" in T ? T.offsetHeight - T.clientHeight - C - S : 0, $ = "offsetWidth" in T ? T.offsetWidth === 0 ? 0 : Z / T.offsetWidth : 0, X = "offsetHeight" in T ? T.offsetHeight === 0 ? 0 : Q / T.offsetHeight : 0;
    if (d === T) P = Be(m, m + O, O, C, S, m + H, m + H + F, F), N = s === "start" ? j : s === "center" ? j - y / 2 : s === "end" ? j - y : Be(E, E + y, y, x, b, E + j, E + j + c, c), P = Math.max(0, P + m), N = Math.max(0, N + E);
    else {
      P = Be(ie, le, Q, C, S + K, H, H + F, F), N = s === "start" ? j - _ - x : s === "center" ? j - (_ + Z / 2) + k / 2 : s === "end" ? j - se + b + k : Be(_, se, Z, x, b + k, j, j + c, c);
      const { scrollLeft: w, scrollTop: te } = T;
      P = X === 0 ? 0 : Math.max(0, Math.min(te + P / X, T.scrollHeight - Q / X + K)), N = $ === 0 ? 0 : Math.max(0, Math.min(w + N / $, T.scrollWidth - Z / $ + k)), H += te - P, j += w - N;
    }
    W.push({ el: T, top: P, left: N });
  }
  return W;
};
var jr = 0;
function on(e) {
  return typeof e == "function" ? e : ue;
}
function ue() {
}
function _n(e, t) {
  if (e) {
    var r = Lr(e, {
      boundary: t
    });
    r.forEach(function(o) {
      var i = o.el, n = o.top, s = o.left;
      i.scrollTop = n, i.scrollLeft = s;
    });
  }
}
function sn(e, t, r) {
  var o = e === t || t instanceof r.Node && e.contains && e.contains(t);
  return o;
}
function wt(e, t) {
  var r;
  function o() {
    r && clearTimeout(r);
  }
  function i() {
    for (var n = arguments.length, s = new Array(n), u = 0; u < n; u++)
      s[u] = arguments[u];
    o(), r = setTimeout(function() {
      r = null, e.apply(void 0, s);
    }, t);
  }
  return i.cancel = o, i;
}
function ne() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(o) {
    for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
      n[s - 1] = arguments[s];
    return t.some(function(u) {
      return u && u.apply(void 0, [o].concat(n)), o.preventDownshiftDefault || o.hasOwnProperty("nativeEvent") && o.nativeEvent.preventDownshiftDefault;
    });
  };
}
function De() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(o) {
    t.forEach(function(i) {
      typeof i == "function" ? i(o) : i && (i.current = o);
    });
  };
}
function yn() {
  return String(jr++);
}
function Kr(e) {
  var t = e.isOpen, r = e.resultCount, o = e.previousResultCount;
  return t ? r ? r !== o ? r + " result" + (r === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function un(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function In(e) {
  return typeof e.type == "string";
}
function En(e) {
  return e.props;
}
function Wr(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var Yr = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function He(e) {
  e === void 0 && (e = {});
  var t = {};
  return Yr.forEach(function(r) {
    e.hasOwnProperty(r) && (t[r] = e[r]);
  }), t;
}
function ze(e, t) {
  return !e || !t ? e : Object.keys(e).reduce(function(r, o) {
    return r[o] = Ge(t, o) ? t[o] : e[o], r;
  }, {});
}
function Ge(e, t) {
  return e[t] !== void 0;
}
function pt(e) {
  var t = e.key, r = e.keyCode;
  return r >= 37 && r <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function Ur(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Oe(e, t, r, o, i) {
  var n = r.length;
  if (n === 0)
    return -1;
  var s = n - 1;
  (typeof e != "number" || e < 0 || e > s) && (e = t > 0 ? -1 : s + 1);
  var u = e + t;
  u < 0 ? u = s : u > s && (u = 0);
  var a = Ae(u, t < 0, r, o, i);
  return a === -1 ? e >= n ? -1 : e : a;
}
function Ae(e, t, r, o, i) {
  i === void 0 && (i = !1);
  var n = r.length;
  if (t) {
    for (var s = e; s >= 0; s--)
      if (!o(r[s], s))
        return s;
  } else
    for (var u = e; u < n; u++)
      if (!o(r[u], u))
        return u;
  return i ? Ae(t ? n - 1 : 0, t, r, o) : -1;
}
function Xe(e, t, r, o) {
  return o === void 0 && (o = !0), r && t.some(function(i) {
    return i && (sn(i, e, r) || o && sn(i, r.document.activeElement, r));
  });
}
var Ct = ue;
process.env.NODE_ENV !== "production" && (Ct = function(t, r, o) {
  var i = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function(n) {
    r[n] !== void 0 && o[n] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + n + '" to be uncontrolled. ' + i) : r[n] === void 0 && o[n] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + n + '" to be controlled. ' + i);
  });
});
var qr = wt(function(e) {
  bn(e).textContent = "";
}, 500);
function bn(e) {
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
function wn(e, t) {
  if (!(!e || !t)) {
    var r = bn(t);
    r.textContent = e, qr(t);
  }
}
function zr(e) {
  var t = e?.getElementById("a11y-status-message");
  t && t.remove();
}
var Cn = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, xn = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, On = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, je = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, Ke = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Dn = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, Sn = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, An = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, Mn = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, Rn = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, Tn = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, Pn = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, Nn = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, ht = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, Vn = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, Fn = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, kn = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, Gr = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blurButton: Vn,
  blurInput: Tn,
  changeInput: Pn,
  clickButton: ht,
  clickItem: Rn,
  controlledPropUpdatedSelectedItem: Fn,
  itemMouseEnter: On,
  keyDownArrowDown: Ke,
  keyDownArrowUp: je,
  keyDownEnd: Mn,
  keyDownEnter: Sn,
  keyDownEscape: Dn,
  keyDownHome: An,
  keyDownSpaceButton: Nn,
  mouseUp: xn,
  touchEnd: kn,
  unknown: Cn
}), Xr = ["refKey", "ref"], Jr = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], Qr = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], Zr = ["refKey", "ref"], eo = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], to = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    function r(i) {
      var n;
      n = t.call(this, i) || this, n.id = n.props.id || "downshift-" + yn(), n.menuId = n.props.menuId || n.id + "-menu", n.labelId = n.props.labelId || n.id + "-label", n.inputId = n.props.inputId || n.id + "-input", n.getItemId = n.props.getItemId || function(c) {
        return n.id + "-item-" + c;
      }, n.items = [], n.itemCount = null, n.previousResultCount = 0, n.timeoutIds = [], n.internalSetTimeout = function(c, h) {
        var p = setTimeout(function() {
          n.timeoutIds = n.timeoutIds.filter(function(f) {
            return f !== p;
          }), c();
        }, h);
        n.timeoutIds.push(p);
      }, n.setItemCount = function(c) {
        n.itemCount = c;
      }, n.unsetItemCount = function() {
        n.itemCount = null;
      }, n.isItemDisabled = function(c, h) {
        var p = n.getItemNodeFromIndex(h);
        return p && p.hasAttribute("disabled");
      }, n.setHighlightedIndex = function(c, h) {
        c === void 0 && (c = n.props.defaultHighlightedIndex), h === void 0 && (h = {}), h = He(h), n.internalSetState(Y({
          highlightedIndex: c
        }, h));
      }, n.clearSelection = function(c) {
        n.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: n.props.defaultHighlightedIndex,
          isOpen: n.props.defaultIsOpen
        }, c);
      }, n.selectItem = function(c, h, p) {
        h = He(h), n.internalSetState(Y({
          isOpen: n.props.defaultIsOpen,
          highlightedIndex: n.props.defaultHighlightedIndex,
          selectedItem: c,
          inputValue: n.props.itemToString(c)
        }, h), p);
      }, n.selectItemAtIndex = function(c, h, p) {
        var f = n.items[c];
        f != null && n.selectItem(f, h, p);
      }, n.selectHighlightedItem = function(c, h) {
        return n.selectItemAtIndex(n.getState().highlightedIndex, c, h);
      }, n.internalSetState = function(c, h) {
        var p, f, M = {}, V = typeof c == "function";
        return !V && c.hasOwnProperty("inputValue") && n.props.onInputValueChange(c.inputValue, Y({}, n.getStateAndHelpers(), c)), n.setState(function(R) {
          var L;
          R = n.getState(R);
          var H = V ? c(R) : c;
          H = n.props.stateReducer(R, H), p = H.hasOwnProperty("selectedItem");
          var j = {};
          return p && H.selectedItem !== R.selectedItem && (f = H.selectedItem), (L = H).type || (L.type = Cn), Object.keys(H).forEach(function(W) {
            R[W] !== H[W] && (M[W] = H[W]), W !== "type" && (H[W], Ge(n.props, W) || (j[W] = H[W]));
          }), V && H.hasOwnProperty("inputValue") && n.props.onInputValueChange(H.inputValue, Y({}, n.getStateAndHelpers(), H)), j;
        }, function() {
          on(h)();
          var R = Object.keys(M).length > 1;
          R && n.props.onStateChange(M, n.getStateAndHelpers()), p && n.props.onSelect(c.selectedItem, n.getStateAndHelpers()), f !== void 0 && n.props.onChange(f, n.getStateAndHelpers()), n.props.onUserAction(M, n.getStateAndHelpers());
        });
      }, n.rootRef = function(c) {
        return n._rootNode = c;
      }, n.getRootProps = function(c, h) {
        var p, f = c === void 0 ? {} : c, M = f.refKey, V = M === void 0 ? "ref" : M, R = f.ref, L = ve(f, Xr), H = h === void 0 ? {} : h, j = H.suppressRefError, W = j === void 0 ? !1 : j;
        n.getRootProps.called = !0, n.getRootProps.refKey = V, n.getRootProps.suppressRefError = W;
        var J = n.getState(), T = J.isOpen;
        return Y((p = {}, p[V] = De(R, n.rootRef), p.role = "combobox", p["aria-expanded"] = T, p["aria-haspopup"] = "listbox", p["aria-owns"] = T ? n.menuId : void 0, p["aria-labelledby"] = n.labelId, p), L);
      }, n.keyDownHandlers = {
        ArrowDown: function(h) {
          var p = this;
          if (h.preventDefault(), this.getState().isOpen) {
            var f = h.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(f, {
              type: Ke
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Ke
            }, function() {
              var M = p.getItemCount();
              if (M > 0) {
                var V = p.getState(), R = V.highlightedIndex, L = Oe(R, 1, {
                  length: M
                }, p.isItemDisabled, !0);
                p.setHighlightedIndex(L, {
                  type: Ke
                });
              }
            });
        },
        ArrowUp: function(h) {
          var p = this;
          if (h.preventDefault(), this.getState().isOpen) {
            var f = h.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(f, {
              type: je
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: je
            }, function() {
              var M = p.getItemCount();
              if (M > 0) {
                var V = p.getState(), R = V.highlightedIndex, L = Oe(R, -1, {
                  length: M
                }, p.isItemDisabled, !0);
                p.setHighlightedIndex(L, {
                  type: je
                });
              }
            });
        },
        Enter: function(h) {
          if (h.which !== 229) {
            var p = this.getState(), f = p.isOpen, M = p.highlightedIndex;
            if (f && M != null) {
              h.preventDefault();
              var V = this.items[M], R = this.getItemNodeFromIndex(M);
              if (V == null || R && R.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: Sn
              });
            }
          }
        },
        Escape: function(h) {
          h.preventDefault(), this.reset(Y({
            type: Dn
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, n.buttonKeyDownHandlers = Y({}, n.keyDownHandlers, {
        " ": function(h) {
          h.preventDefault(), this.toggleMenu({
            type: Nn
          });
        }
      }), n.inputKeyDownHandlers = Y({}, n.keyDownHandlers, {
        Home: function(h) {
          var p = this.getState(), f = p.isOpen;
          if (f) {
            h.preventDefault();
            var M = this.getItemCount();
            if (!(M <= 0 || !f)) {
              var V = Ae(0, !1, {
                length: M
              }, this.isItemDisabled);
              this.setHighlightedIndex(V, {
                type: An
              });
            }
          }
        },
        End: function(h) {
          var p = this.getState(), f = p.isOpen;
          if (f) {
            h.preventDefault();
            var M = this.getItemCount();
            if (!(M <= 0 || !f)) {
              var V = Ae(M - 1, !0, {
                length: M
              }, this.isItemDisabled);
              this.setHighlightedIndex(V, {
                type: Mn
              });
            }
          }
        }
      }), n.getToggleButtonProps = function(c) {
        var h = c === void 0 ? {} : c, p = h.onClick;
        h.onPress;
        var f = h.onKeyDown, M = h.onKeyUp, V = h.onBlur, R = ve(h, Jr), L = n.getState(), H = L.isOpen, j = {
          onClick: ne(p, n.buttonHandleClick),
          onKeyDown: ne(f, n.buttonHandleKeyDown),
          onKeyUp: ne(M, n.buttonHandleKeyUp),
          onBlur: ne(V, n.buttonHandleBlur)
        }, W = R.disabled ? {} : j;
        return Y({
          type: "button",
          role: "button",
          "aria-label": H ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, W, R);
      }, n.buttonHandleKeyUp = function(c) {
        c.preventDefault();
      }, n.buttonHandleKeyDown = function(c) {
        var h = pt(c);
        n.buttonKeyDownHandlers[h] && n.buttonKeyDownHandlers[h].call(n, c);
      }, n.buttonHandleClick = function(c) {
        if (c.preventDefault(), n.props.environment) {
          var h = n.props.environment.document, p = h.body, f = h.activeElement;
          p && p === f && c.target.focus();
        }
        process.env.NODE_ENV === "test" ? n.toggleMenu({
          type: ht
        }) : n.internalSetTimeout(function() {
          return n.toggleMenu({
            type: ht
          });
        });
      }, n.buttonHandleBlur = function(c) {
        var h = c.target;
        n.internalSetTimeout(function() {
          if (!(n.isMouseDown || !n.props.environment)) {
            var p = n.props.environment.document.activeElement;
            (p == null || p.id !== n.inputId) && p !== h && n.reset({
              type: Vn
            });
          }
        });
      }, n.getLabelProps = function(c) {
        return Y({
          htmlFor: n.inputId,
          id: n.labelId
        }, c);
      }, n.getInputProps = function(c) {
        var h = c === void 0 ? {} : c, p = h.onKeyDown, f = h.onBlur, M = h.onChange, V = h.onInput;
        h.onChangeText;
        var R = ve(h, Qr), L, H = {};
        L = "onChange";
        var j = n.getState(), W = j.inputValue, J = j.isOpen, T = j.highlightedIndex;
        if (!R.disabled) {
          var Q;
          H = (Q = {}, Q[L] = ne(M, V, n.inputHandleChange), Q.onKeyDown = ne(p, n.inputHandleKeyDown), Q.onBlur = ne(f, n.inputHandleBlur), Q);
        }
        return Y({
          "aria-autocomplete": "list",
          "aria-activedescendant": J && typeof T == "number" && T >= 0 ? n.getItemId(T) : void 0,
          "aria-controls": J ? n.menuId : void 0,
          "aria-labelledby": R && R["aria-label"] ? void 0 : n.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: W,
          id: n.inputId
        }, H, R);
      }, n.inputHandleKeyDown = function(c) {
        var h = pt(c);
        h && n.inputKeyDownHandlers[h] && n.inputKeyDownHandlers[h].call(n, c);
      }, n.inputHandleChange = function(c) {
        n.internalSetState({
          type: Pn,
          isOpen: !0,
          inputValue: c.target.value,
          highlightedIndex: n.props.defaultHighlightedIndex
        });
      }, n.inputHandleBlur = function() {
        n.internalSetTimeout(function() {
          var c;
          if (!(n.isMouseDown || !n.props.environment)) {
            var h = n.props.environment.document.activeElement, p = (h == null || (c = h.dataset) == null ? void 0 : c.toggle) && n._rootNode && n._rootNode.contains(h);
            p || n.reset({
              type: Tn
            });
          }
        });
      }, n.menuRef = function(c) {
        n._menuNode = c;
      }, n.getMenuProps = function(c, h) {
        var p, f = c === void 0 ? {} : c, M = f.refKey, V = M === void 0 ? "ref" : M, R = f.ref, L = ve(f, Zr), H = h === void 0 ? {} : h, j = H.suppressRefError, W = j === void 0 ? !1 : j;
        return n.getMenuProps.called = !0, n.getMenuProps.refKey = V, n.getMenuProps.suppressRefError = W, Y((p = {}, p[V] = De(R, n.menuRef), p.role = "listbox", p["aria-labelledby"] = L && L["aria-label"] ? void 0 : n.labelId, p.id = n.menuId, p), L);
      }, n.getItemProps = function(c) {
        var h, p = c === void 0 ? {} : c, f = p.onMouseMove, M = p.onMouseDown, V = p.onClick;
        p.onPress;
        var R = p.index, L = p.item, H = L === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : Wr("getItemProps", "item") : L, j = ve(p, eo);
        R === void 0 ? (n.items.push(H), R = n.items.indexOf(H)) : n.items[R] = H;
        var W = "onClick", J = V, T = (h = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: ne(f, function() {
            R !== n.getState().highlightedIndex && (n.setHighlightedIndex(R, {
              type: On
            }), n.avoidScrolling = !0, n.internalSetTimeout(function() {
              return n.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: ne(M, function(Z) {
            Z.preventDefault();
          })
        }, h[W] = ne(J, function() {
          n.selectItemAtIndex(R, {
            type: Rn
          });
        }), h), Q = j.disabled ? {
          onMouseDown: T.onMouseDown
        } : T;
        return Y({
          id: n.getItemId(R),
          role: "option",
          "aria-selected": n.getState().highlightedIndex === R
        }, Q, j);
      }, n.clearItems = function() {
        n.items = [];
      }, n.reset = function(c, h) {
        c === void 0 && (c = {}), c = He(c), n.internalSetState(function(p) {
          var f = p.selectedItem;
          return Y({
            isOpen: n.props.defaultIsOpen,
            highlightedIndex: n.props.defaultHighlightedIndex,
            inputValue: n.props.itemToString(f)
          }, c);
        }, h);
      }, n.toggleMenu = function(c, h) {
        c === void 0 && (c = {}), c = He(c), n.internalSetState(function(p) {
          var f = p.isOpen;
          return Y({
            isOpen: !f
          }, f && {
            highlightedIndex: n.props.defaultHighlightedIndex
          }, c);
        }, function() {
          var p = n.getState(), f = p.isOpen, M = p.highlightedIndex;
          f && n.getItemCount() > 0 && typeof M == "number" && n.setHighlightedIndex(M, c), on(h)();
        });
      }, n.openMenu = function(c) {
        n.internalSetState({
          isOpen: !0
        }, c);
      }, n.closeMenu = function(c) {
        n.internalSetState({
          isOpen: !1
        }, c);
      }, n.updateStatus = wt(function() {
        var c;
        if ((c = n.props) != null && (c = c.environment) != null && c.document) {
          var h = n.getState(), p = n.items[h.highlightedIndex], f = n.getItemCount(), M = n.props.getA11yStatusMessage(Y({
            itemToString: n.props.itemToString,
            previousResultCount: n.previousResultCount,
            resultCount: f,
            highlightedItem: p
          }, h));
          n.previousResultCount = f, wn(M, n.props.environment.document);
        }
      }, 200);
      var s = n.props, u = s.defaultHighlightedIndex, a = s.initialHighlightedIndex, l = a === void 0 ? u : a, d = s.defaultIsOpen, g = s.initialIsOpen, v = g === void 0 ? d : g, y = s.initialInputValue, O = y === void 0 ? "" : y, E = s.initialSelectedItem, m = E === void 0 ? null : E, F = n.getState({
        highlightedIndex: l,
        isOpen: v,
        inputValue: O,
        selectedItem: m
      });
      return F.selectedItem != null && n.props.initialInputValue === void 0 && (F.inputValue = n.props.itemToString(F.selectedItem)), n.state = F, n;
    }
    Sr(r, t);
    var o = r.prototype;
    return o.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(n) {
        clearTimeout(n);
      }), this.timeoutIds = [];
    }, o.getState = function(n) {
      return n === void 0 && (n = this.state), ze(n, this.props);
    }, o.getItemCount = function() {
      var n = this.items.length;
      return this.itemCount != null ? n = this.itemCount : this.props.itemCount !== void 0 && (n = this.props.itemCount), n;
    }, o.getItemNodeFromIndex = function(n) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(n)) : null;
    }, o.scrollHighlightedItemIntoView = function() {
      {
        var n = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(n, this._menuNode);
      }
    }, o.moveHighlightedIndex = function(n, s) {
      var u = this.getItemCount(), a = this.getState(), l = a.highlightedIndex;
      if (u > 0) {
        var d = Oe(l, n, {
          length: u
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(d, s);
      }
    }, o.getStateAndHelpers = function() {
      var n = this.getState(), s = n.highlightedIndex, u = n.inputValue, a = n.selectedItem, l = n.isOpen, d = this.props.itemToString, g = this.id, v = this.getRootProps, y = this.getToggleButtonProps, O = this.getLabelProps, E = this.getMenuProps, m = this.getInputProps, F = this.getItemProps, c = this.openMenu, h = this.closeMenu, p = this.toggleMenu, f = this.selectItem, M = this.selectItemAtIndex, V = this.selectHighlightedItem, R = this.setHighlightedIndex, L = this.clearSelection, H = this.clearItems, j = this.reset, W = this.setItemCount, J = this.unsetItemCount, T = this.internalSetState;
      return {
        // prop getters
        getRootProps: v,
        getToggleButtonProps: y,
        getLabelProps: O,
        getMenuProps: E,
        getInputProps: m,
        getItemProps: F,
        // actions
        reset: j,
        openMenu: c,
        closeMenu: h,
        toggleMenu: p,
        selectItem: f,
        selectItemAtIndex: M,
        selectHighlightedItem: V,
        setHighlightedIndex: R,
        clearSelection: L,
        clearItems: H,
        setItemCount: W,
        unsetItemCount: J,
        setState: T,
        // props
        itemToString: d,
        // derived
        id: g,
        // state
        highlightedIndex: s,
        inputValue: u,
        isOpen: l,
        selectedItem: a
      };
    }, o.componentDidMount = function() {
      var n = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && an(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          n.internalClearTimeouts();
        };
      else {
        var s = function() {
          n.isMouseDown = !0;
        }, u = function(y) {
          n.isMouseDown = !1;
          var O = Xe(y.target, [n._rootNode, n._menuNode], n.props.environment);
          !O && n.getState().isOpen && n.reset({
            type: xn
          }, function() {
            return n.props.onOuterClick(n.getStateAndHelpers());
          });
        }, a = function() {
          n.isTouchMove = !1;
        }, l = function() {
          n.isTouchMove = !0;
        }, d = function(y) {
          var O = Xe(y.target, [n._rootNode, n._menuNode], n.props.environment, !1);
          !n.isTouchMove && !O && n.getState().isOpen && n.reset({
            type: kn
          }, function() {
            return n.props.onOuterClick(n.getStateAndHelpers());
          });
        }, g = this.props.environment;
        g.addEventListener("mousedown", s), g.addEventListener("mouseup", u), g.addEventListener("touchstart", a), g.addEventListener("touchmove", l), g.addEventListener("touchend", d), this.cleanup = function() {
          n.internalClearTimeouts(), n.updateStatus.cancel(), g.removeEventListener("mousedown", s), g.removeEventListener("mouseup", u), g.removeEventListener("touchstart", a), g.removeEventListener("touchmove", l), g.removeEventListener("touchend", d);
        };
      }
    }, o.shouldScroll = function(n, s) {
      var u = this.props.highlightedIndex === void 0 ? this.getState() : this.props, a = u.highlightedIndex, l = s.highlightedIndex === void 0 ? n : s, d = l.highlightedIndex, g = a && this.getState().isOpen && !n.isOpen, v = a !== d;
      return g || v;
    }, o.componentDidUpdate = function(n, s) {
      process.env.NODE_ENV !== "production" && (Ct(this.state, n, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && an(this._menuNode, this.getMenuProps)), Ge(this.props, "selectedItem") && this.props.selectedItemChanged(n.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: Fn,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(s, n) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, o.componentWillUnmount = function() {
      this.cleanup();
    }, o.render = function() {
      var n = un(this.props.children, ue);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var s = un(n(this.getStateAndHelpers()));
      if (!s)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && no(s, this.getRootProps), s;
      if (In(s))
        return /* @__PURE__ */ fr(s, this.getRootProps(En(s)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, r;
  }(pr);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: Kr,
    itemToString: function(r) {
      return r == null ? "" : (process.env.NODE_ENV !== "production" && Ur(r) && !r.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", r), String(r));
    },
    onStateChange: ue,
    onInputValueChange: ue,
    onUserAction: ue,
    onChange: ue,
    onSelect: ue,
    onOuterClick: ue,
    selectedItemChanged: function(r, o) {
      return r !== o;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(r, o) {
      return o;
    },
    suppressRefError: !1,
    scrollIntoView: _n
  }, e.stateChangeTypes = Gr, e;
}();
process.env.NODE_ENV !== "production" && (to.propTypes = {
  children: I.func,
  defaultHighlightedIndex: I.number,
  defaultIsOpen: I.bool,
  initialHighlightedIndex: I.number,
  initialSelectedItem: I.any,
  initialInputValue: I.string,
  initialIsOpen: I.bool,
  getA11yStatusMessage: I.func,
  itemToString: I.func,
  onChange: I.func,
  onSelect: I.func,
  onStateChange: I.func,
  onInputValueChange: I.func,
  onUserAction: I.func,
  onOuterClick: I.func,
  selectedItemChanged: I.func,
  stateReducer: I.func,
  itemCount: I.number,
  id: I.string,
  environment: I.shape({
    addEventListener: I.func.isRequired,
    removeEventListener: I.func.isRequired,
    document: I.shape({
      createElement: I.func.isRequired,
      getElementById: I.func.isRequired,
      activeElement: I.any.isRequired,
      body: I.any.isRequired
    }).isRequired,
    Node: I.func.isRequired
  }),
  suppressRefError: I.bool,
  scrollIntoView: I.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: I.any,
  isOpen: I.bool,
  inputValue: I.string,
  highlightedIndex: I.number,
  labelId: I.string,
  inputId: I.string,
  menuId: I.string,
  getItemId: I.func
  /* eslint-enable react/no-unused-prop-types */
});
function an(e, t) {
  var r = t.refKey;
  e || console.error('downshift: The ref prop "' + r + '" from getMenuProps was not applied correctly on your menu element.');
}
function no(e, t) {
  var r = t.refKey, o = r !== "ref", i = !In(e);
  i && !o && !tn.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !i && o && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + r + '"'), !tn.isForwardRef(e) && !En(e)[r] && console.error('downshift: You must apply the ref prop "' + r + '" from getRootProps onto your root element.');
}
var $n = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function ro(e, t, r) {
  var o = e.props, i = e.type, n = {};
  Object.keys(t).forEach(function(s) {
    oo(s, e, t, r), r[s] !== t[s] && (n[s] = r[s]);
  }), o.onStateChange && Object.keys(n).length && o.onStateChange(Y({
    type: i
  }, n));
}
function oo(e, t, r, o) {
  var i = t.props, n = t.type, s = "on" + xt(e) + "Change";
  i[s] && o[e] !== void 0 && o[e] !== r[e] && i[s](Y({
    type: n
  }, o));
}
function io(e, t) {
  return t.changes;
}
var cn = wt(function(e, t) {
  wn(e, t);
}, 200), so = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? lr : ce, uo = "useId" in Ue ? function(t) {
  var r = t.id, o = t.labelId, i = t.menuId, n = t.getItemId, s = t.toggleButtonId, u = t.inputId, a = "downshift-" + Ue.useId();
  r || (r = a);
  var l = oe({
    labelId: o || r + "-label",
    menuId: i || r + "-menu",
    getItemId: n || function(d) {
      return r + "-item-" + d;
    },
    toggleButtonId: s || r + "-toggle-button",
    inputId: u || r + "-input"
  });
  return l.current;
} : function(t) {
  var r = t.id, o = r === void 0 ? "downshift-" + yn() : r, i = t.labelId, n = t.menuId, s = t.getItemId, u = t.toggleButtonId, a = t.inputId, l = oe({
    labelId: i || o + "-label",
    menuId: n || o + "-menu",
    getItemId: s || function(d) {
      return o + "-item-" + d;
    },
    toggleButtonId: u || o + "-toggle-button",
    inputId: a || o + "-input"
  });
  return l.current;
};
function ao(e, t, r, o) {
  var i, n;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(o);
    i = r[t], n = t;
  } else
    n = t === void 0 ? r.indexOf(e) : t, i = e;
  return [i, n];
}
function xt(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function Bn(e) {
  var t = oe(e);
  return t.current = e, t;
}
function co(e, t, r, o) {
  var i = oe(), n = oe(), s = re(function(y, O) {
    n.current = O, y = ze(y, O.props);
    var E = e(y, O), m = O.props.stateReducer(y, Y({}, O, {
      changes: E
    }));
    return m;
  }, [e]), u = dr(s, t, r), a = u[0], l = u[1], d = Bn(t), g = re(function(y) {
    return l(Y({
      props: d.current
    }, y));
  }, [d]), v = n.current;
  return ce(function() {
    var y = ze(i.current, v?.props), O = v && i.current && !o(y, a);
    O && ro(v, y, a), i.current = a;
  }, [a, v, o]), [a, g];
}
var Te = {
  itemToString: function(t) {
    return t ? String(t) : "";
  },
  itemToKey: function(t) {
    return t;
  },
  stateReducer: io,
  scrollIntoView: _n,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function Ee(e, t, r) {
  r === void 0 && (r = $n);
  var o = e["default" + xt(t)];
  return o !== void 0 ? o : r[t];
}
function Pe(e, t, r) {
  r === void 0 && (r = $n);
  var o = e[t];
  if (o !== void 0)
    return o;
  var i = e["initial" + xt(t)];
  return i !== void 0 ? i : Ee(e, t, r);
}
function lo(e) {
  var t = Pe(e, "selectedItem"), r = Pe(e, "isOpen"), o = mo(e), i = Pe(e, "inputValue");
  return {
    highlightedIndex: o < 0 && t && r ? e.items.findIndex(function(n) {
      return e.itemToKey(n) === e.itemToKey(t);
    }) : o,
    isOpen: r,
    selectedItem: t,
    inputValue: i
  };
}
function Ne(e, t, r) {
  var o = e.items, i = e.initialHighlightedIndex, n = e.defaultHighlightedIndex, s = e.isItemDisabled, u = e.itemToKey, a = t.selectedItem, l = t.highlightedIndex;
  return o.length === 0 ? -1 : i !== void 0 && l === i && !s(o[i], i) ? i : n !== void 0 && !s(o[n], n) ? n : a ? o.findIndex(function(d) {
    return u(a) === u(d);
  }) : r < 0 && !s(o[o.length - 1], o.length - 1) ? o.length - 1 : r > 0 && !s(o[0], 0) ? 0 : -1;
}
function fo(e, t, r) {
  var o = oe({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return ce(function() {
    if (!e)
      return ue;
    var i = r.map(function(d) {
      return d.current;
    });
    function n() {
      o.current.isTouchEnd = !1, o.current.isMouseDown = !0;
    }
    function s(d) {
      o.current.isMouseDown = !1, Xe(d.target, i, e) || t();
    }
    function u() {
      o.current.isTouchEnd = !1, o.current.isTouchMove = !1;
    }
    function a() {
      o.current.isTouchMove = !0;
    }
    function l(d) {
      o.current.isTouchEnd = !0, !o.current.isTouchMove && !Xe(d.target, i, e, !1) && t();
    }
    return e.addEventListener("mousedown", n), e.addEventListener("mouseup", s), e.addEventListener("touchstart", u), e.addEventListener("touchmove", a), e.addEventListener("touchend", l), function() {
      e.removeEventListener("mousedown", n), e.removeEventListener("mouseup", s), e.removeEventListener("touchstart", u), e.removeEventListener("touchmove", a), e.removeEventListener("touchend", l);
    };
  }, [r, e, t]), o.current;
}
var Hn = function() {
  return ue;
};
process.env.NODE_ENV !== "production" && (Hn = function() {
  for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++)
    r[o] = arguments[o];
  var i = oe(r.reduce(function(s, u) {
    return s[u] = {}, s;
  }, {}));
  ce(function() {
    Object.keys(i.current).forEach(function(s) {
      var u = i.current[s];
      if (!Object.keys(u).length) {
        console.error("downshift: You forgot to call the " + s + " getter function on your component / element.");
        return;
      }
      var a = u.suppressRefError, l = u.refKey, d = u.elementRef;
      a || d != null && d.current || console.error('downshift: The ref prop "' + l + '" from ' + s + " was not applied correctly on your element.");
    });
  }, []);
  var n = re(function(s, u, a, l) {
    i.current[s] = {
      suppressRefError: u,
      refKey: a,
      elementRef: l
    };
  }, []);
  return n;
});
function po(e, t, r, o) {
  o === void 0 && (o = {});
  var i = o.document, n = et();
  ce(function() {
    if (!(!e || n || !i)) {
      var s = e(t);
      cn(s, i);
    }
  }, r), ce(function() {
    return function() {
      cn.cancel(), zr(i);
    };
  }, [i]);
}
function ho(e) {
  var t = e.highlightedIndex, r = e.isOpen, o = e.itemRefs, i = e.getItemNodeFromIndex, n = e.menuElement, s = e.scrollIntoView, u = oe(!0);
  return so(function() {
    t < 0 || !r || !Object.keys(o.current).length || (u.current === !1 ? u.current = !0 : s(i(t), n));
  }, [t]), u;
}
var Ln = ue;
process.env.NODE_ENV !== "production" && (Ln = function(t) {
  var r = t.props, o = t.state, i = oe(r), n = et();
  ce(function() {
    n || (Ct(o, i.current, r), i.current = r);
  }, [o, r, n]);
});
function ln(e, t, r) {
  var o;
  r === void 0 && (r = !0);
  var i = ((o = e.items) == null ? void 0 : o.length) && t >= 0;
  return Y({
    isOpen: !1,
    highlightedIndex: -1
  }, i && Y({
    selectedItem: e.items[t],
    isOpen: Ee(e, "isOpen"),
    highlightedIndex: Ee(e, "highlightedIndex")
  }, r && {
    inputValue: e.itemToString(e.items[t])
  }));
}
function go(e, t) {
  return e.isOpen === t.isOpen && e.inputValue === t.inputValue && e.highlightedIndex === t.highlightedIndex && e.selectedItem === t.selectedItem;
}
function et() {
  var e = Ue.useRef(!0);
  return Ue.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []), e.current;
}
function gt(e) {
  var t = Ee(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
function mo(e) {
  var t = Pe(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
var We = {
  environment: I.shape({
    addEventListener: I.func.isRequired,
    removeEventListener: I.func.isRequired,
    document: I.shape({
      createElement: I.func.isRequired,
      getElementById: I.func.isRequired,
      activeElement: I.any.isRequired,
      body: I.any.isRequired
    }).isRequired,
    Node: I.func.isRequired
  }),
  itemToString: I.func,
  itemToKey: I.func,
  stateReducer: I.func
}, jn = Y({}, We, {
  getA11yStatusMessage: I.func,
  highlightedIndex: I.number,
  defaultHighlightedIndex: I.number,
  initialHighlightedIndex: I.number,
  isOpen: I.bool,
  defaultIsOpen: I.bool,
  initialIsOpen: I.bool,
  selectedItem: I.any,
  initialSelectedItem: I.any,
  defaultSelectedItem: I.any,
  id: I.string,
  labelId: I.string,
  menuId: I.string,
  getItemId: I.func,
  toggleButtonId: I.string,
  onSelectedItemChange: I.func,
  onHighlightedIndexChange: I.func,
  onStateChange: I.func,
  onIsOpenChange: I.func,
  scrollIntoView: I.func
});
function vo(e, t, r) {
  var o = t.type, i = t.props, n;
  switch (o) {
    case r.ItemMouseMove:
      n = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case r.MenuMouseLeave:
      n = {
        highlightedIndex: -1
      };
      break;
    case r.ToggleButtonClick:
    case r.FunctionToggleMenu:
      n = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : Ne(i, e, 0)
      };
      break;
    case r.FunctionOpenMenu:
      n = {
        isOpen: !0,
        highlightedIndex: Ne(i, e, 0)
      };
      break;
    case r.FunctionCloseMenu:
      n = {
        isOpen: !1
      };
      break;
    case r.FunctionSetHighlightedIndex:
      n = {
        highlightedIndex: i.isItemDisabled(i.items[t.highlightedIndex], t.highlightedIndex) ? -1 : t.highlightedIndex
      };
      break;
    case r.FunctionSetInputValue:
      n = {
        inputValue: t.inputValue
      };
      break;
    case r.FunctionReset:
      n = {
        highlightedIndex: gt(i),
        isOpen: Ee(i, "isOpen"),
        selectedItem: Ee(i, "selectedItem"),
        inputValue: Ee(i, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return Y({}, e, n);
}
qe(qe({}, jn), { items: I.array.isRequired, isItemDisabled: I.func });
qe(qe({}, Te), { isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var Ot = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Dt = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, St = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, At = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Mt = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, Rt = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Tt = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, Pt = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, Nt = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, Je = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Vt = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, Kn = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, Wn = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, Ft = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, Yn = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, Un = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, qn = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, zn = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, Gn = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, kt = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Xn = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, Jn = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, $_t = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, Qn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ControlledPropUpdatedSelectedItem: $_t,
  FunctionCloseMenu: zn,
  FunctionOpenMenu: qn,
  FunctionReset: Jn,
  FunctionSelectItem: kt,
  FunctionSetHighlightedIndex: Gn,
  FunctionSetInputValue: Xn,
  FunctionToggleMenu: Un,
  InputBlur: Je,
  InputChange: Nt,
  InputClick: Vt,
  InputKeyDownArrowDown: Ot,
  InputKeyDownArrowUp: Dt,
  InputKeyDownEnd: Mt,
  InputKeyDownEnter: Pt,
  InputKeyDownEscape: St,
  InputKeyDownHome: At,
  InputKeyDownPageDown: Tt,
  InputKeyDownPageUp: Rt,
  ItemClick: Ft,
  ItemMouseMove: Wn,
  MenuMouseLeave: Kn,
  ToggleButtonClick: Yn
});
function _o(e) {
  var t = lo(e), r = t.selectedItem, o = t.inputValue;
  return o === "" && r && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (o = e.itemToString(r)), Y({}, t, {
    inputValue: o
  });
}
var yo = Y({}, jn, {
  items: I.array.isRequired,
  isItemDisabled: I.func,
  inputValue: I.string,
  defaultInputValue: I.string,
  initialInputValue: I.string,
  inputId: I.string,
  onInputValueChange: I.func
});
function Io(e, t, r, o) {
  var i = oe(), n = co(e, t, r, o), s = n[0], u = n[1], a = et();
  return ce(function() {
    if (Ge(t, "selectedItem")) {
      if (!a) {
        var l = t.itemToKey(t.selectedItem) !== t.itemToKey(i.current);
        l && u({
          type: $_t,
          inputValue: t.itemToString(t.selectedItem)
        });
      }
      i.current = s.selectedItem === i.current ? t.selectedItem : s.selectedItem;
    }
  }, [s.selectedItem, t.selectedItem]), [ze(s, t), u];
}
var Zn = ue;
process.env.NODE_ENV !== "production" && (Zn = function(t, r) {
  I.checkPropTypes(yo, t, "prop", r.name);
});
var Eo = Y({}, Te, {
  isItemDisabled: function() {
    return !1;
  }
});
function bo(e, t) {
  var r, o = t.type, i = t.props, n = t.altKey, s;
  switch (o) {
    case Ft:
      s = {
        isOpen: Ee(i, "isOpen"),
        highlightedIndex: gt(i),
        selectedItem: i.items[t.index],
        inputValue: i.itemToString(i.items[t.index])
      };
      break;
    case Ot:
      e.isOpen ? s = {
        highlightedIndex: Oe(e.highlightedIndex, 1, i.items, i.isItemDisabled, !0)
      } : s = {
        highlightedIndex: n && e.selectedItem == null ? -1 : Ne(i, e, 1),
        isOpen: i.items.length >= 0
      };
      break;
    case Dt:
      e.isOpen ? n ? s = ln(i, e.highlightedIndex) : s = {
        highlightedIndex: Oe(e.highlightedIndex, -1, i.items, i.isItemDisabled, !0)
      } : s = {
        highlightedIndex: Ne(i, e, -1),
        isOpen: i.items.length >= 0
      };
      break;
    case Pt:
      s = ln(i, e.highlightedIndex);
      break;
    case St:
      s = Y({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case Rt:
      s = {
        highlightedIndex: Oe(e.highlightedIndex, -10, i.items, i.isItemDisabled, !0)
      };
      break;
    case Tt:
      s = {
        highlightedIndex: Oe(e.highlightedIndex, 10, i.items, i.isItemDisabled, !0)
      };
      break;
    case At:
      s = {
        highlightedIndex: Ae(0, !1, i.items, i.isItemDisabled)
      };
      break;
    case Mt:
      s = {
        highlightedIndex: Ae(i.items.length - 1, !0, i.items, i.isItemDisabled)
      };
      break;
    case Je:
      s = Y({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((r = i.items) == null ? void 0 : r.length) && t.selectItem && {
        selectedItem: i.items[e.highlightedIndex],
        inputValue: i.itemToString(i.items[e.highlightedIndex])
      });
      break;
    case Nt:
      s = {
        isOpen: !0,
        highlightedIndex: gt(i),
        inputValue: t.inputValue
      };
      break;
    case Vt:
      s = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : Ne(i, e, 0)
      };
      break;
    case kt:
      s = {
        selectedItem: t.selectedItem,
        inputValue: i.itemToString(t.selectedItem)
      };
      break;
    case $_t:
      s = {
        inputValue: t.inputValue
      };
      break;
    default:
      return vo(e, t, Qn);
  }
  return Y({}, e, s);
}
var wo = ["onMouseLeave", "refKey", "ref"], Co = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], xo = ["onClick", "onPress", "refKey", "ref"], Oo = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
Bt.stateChangeTypes = Qn;
function Bt(e) {
  e === void 0 && (e = {}), Zn(e, Bt);
  var t = Y({}, Eo, e), r = t.items, o = t.scrollIntoView, i = t.environment, n = t.getA11yStatusMessage, s = Io(bo, t, _o, go), u = s[0], a = s[1], l = u.isOpen, d = u.highlightedIndex, g = u.selectedItem, v = u.inputValue, y = oe(null), O = oe({}), E = oe(null), m = oe(null), F = et(), c = uo(t), h = oe(), p = Bn({
    state: u,
    props: t
  }), f = re(function(x) {
    return O.current[c.getItemId(x)];
  }, [c]);
  po(n, u, [l, d, g, v], i);
  var M = ho({
    menuElement: y.current,
    highlightedIndex: d,
    isOpen: l,
    itemRefs: O,
    scrollIntoView: o,
    getItemNodeFromIndex: f
  });
  Ln({
    props: t,
    state: u
  }), ce(function() {
    var x = Pe(t, "isOpen");
    x && E.current && E.current.focus();
  }, []), ce(function() {
    F || (h.current = r.length);
  });
  var V = fo(i, re(function() {
    p.current.state.isOpen && a({
      type: Je,
      selectItem: !1
    });
  }, [a, p]), jt(function() {
    return [y, m, E];
  }, [y.current, m.current, E.current])), R = Hn("getInputProps", "getMenuProps");
  ce(function() {
    l || (O.current = {});
  }, [l]), ce(function() {
    var x;
    !l || !(i != null && i.document) || !(E != null && (x = E.current) != null && x.focus) || i.document.activeElement !== E.current && E.current.focus();
  }, [l, i]);
  var L = jt(function() {
    return {
      ArrowDown: function(C) {
        C.preventDefault(), a({
          type: Ot,
          altKey: C.altKey
        });
      },
      ArrowUp: function(C) {
        C.preventDefault(), a({
          type: Dt,
          altKey: C.altKey
        });
      },
      Home: function(C) {
        p.current.state.isOpen && (C.preventDefault(), a({
          type: At
        }));
      },
      End: function(C) {
        p.current.state.isOpen && (C.preventDefault(), a({
          type: Mt
        }));
      },
      Escape: function(C) {
        var b = p.current.state;
        (b.isOpen || b.inputValue || b.selectedItem || b.highlightedIndex > -1) && (C.preventDefault(), a({
          type: St
        }));
      },
      Enter: function(C) {
        var b = p.current.state;
        !b.isOpen || C.which === 229 || (C.preventDefault(), a({
          type: Pt
        }));
      },
      PageUp: function(C) {
        p.current.state.isOpen && (C.preventDefault(), a({
          type: Rt
        }));
      },
      PageDown: function(C) {
        p.current.state.isOpen && (C.preventDefault(), a({
          type: Tt
        }));
      }
    };
  }, [a, p]), H = re(function(x) {
    return Y({
      id: c.labelId,
      htmlFor: c.inputId
    }, x);
  }, [c]), j = re(function(x, C) {
    var b, S = x === void 0 ? {} : x, P = S.onMouseLeave, N = S.refKey, k = N === void 0 ? "ref" : N, K = S.ref, $ = ve(S, wo), X = C === void 0 ? {} : C, w = X.suppressRefError, te = w === void 0 ? !1 : w;
    return R("getMenuProps", te, k, y), Y((b = {}, b[k] = De(K, function(A) {
      y.current = A;
    }), b.id = c.menuId, b.role = "listbox", b["aria-labelledby"] = $ && $["aria-label"] ? void 0 : "" + c.labelId, b.onMouseLeave = ne(P, function() {
      a({
        type: Kn
      });
    }), b), $);
  }, [a, R, c]), W = re(function(x) {
    var C, b, S = x === void 0 ? {} : x, P = S.item, N = S.index, k = S.refKey, K = k === void 0 ? "ref" : k, $ = S.ref, X = S.onMouseMove, w = S.onMouseDown, te = S.onClick;
    S.onPress;
    var A = S.disabled, fe = ve(S, Co);
    A !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var pe = p.current, we = pe.props, ge = pe.state, Ve = ao(P, N, we.items, "Pass either item or index to getItemProps!"), tt = Ve[0], me = Ve[1], Re = we.isItemDisabled(tt, me), nt = "onClick", Fe = te, ye = function() {
      V.isTouchEnd || me === ge.highlightedIndex || (M.current = !1, a({
        type: Wn,
        index: me,
        disabled: Re
      }));
    }, Ce = function() {
      a({
        type: Ft,
        index: me
      });
    }, Ie = function(cr) {
      return cr.preventDefault();
    };
    return Y((C = {}, C[K] = De($, function(de) {
      de && (O.current[c.getItemId(me)] = de);
    }), C["aria-disabled"] = Re, C["aria-selected"] = me === ge.highlightedIndex, C.id = c.getItemId(me), C.role = "option", C), !Re && (b = {}, b[nt] = ne(Fe, Ce), b), {
      onMouseMove: ne(X, ye),
      onMouseDown: ne(w, Ie)
    }, fe);
  }, [a, c, p, V, M]), J = re(function(x) {
    var C, b = x === void 0 ? {} : x, S = b.onClick;
    b.onPress;
    var P = b.refKey, N = P === void 0 ? "ref" : P, k = b.ref, K = ve(b, xo), $ = p.current.state, X = function() {
      a({
        type: Yn
      });
    };
    return Y((C = {}, C[N] = De(k, function(w) {
      m.current = w;
    }), C["aria-controls"] = c.menuId, C["aria-expanded"] = $.isOpen, C.id = c.toggleButtonId, C.tabIndex = -1, C), !K.disabled && Y({}, {
      onClick: ne(S, X)
    }), K);
  }, [a, p, c]), T = re(function(x, C) {
    var b, S = x === void 0 ? {} : x, P = S.onKeyDown, N = S.onChange, k = S.onInput, K = S.onBlur;
    S.onChangeText;
    var $ = S.onClick, X = S.refKey, w = X === void 0 ? "ref" : X, te = S.ref, A = ve(S, Oo), fe = C === void 0 ? {} : C, pe = fe.suppressRefError, we = pe === void 0 ? !1 : pe;
    R("getInputProps", we, w, E);
    var ge = p.current.state, Ve = function(Ie) {
      var de = pt(Ie);
      de && L[de] && L[de](Ie);
    }, tt = function(Ie) {
      a({
        type: Nt,
        inputValue: Ie.target.value
      });
    }, me = function(Ie) {
      if (i != null && i.document && ge.isOpen && !V.isMouseDown) {
        var de = Ie.relatedTarget === null && i.document.activeElement !== i.document.body;
        a({
          type: Je,
          selectItem: !de
        });
      }
    }, Re = function() {
      a({
        type: Vt
      });
    }, nt = "onChange", Fe = {};
    if (!A.disabled) {
      var ye;
      Fe = (ye = {}, ye[nt] = ne(N, k, tt), ye.onKeyDown = ne(P, Ve), ye.onBlur = ne(K, me), ye.onClick = ne($, Re), ye);
    }
    return Y((b = {}, b[w] = De(te, function(Ce) {
      E.current = Ce;
    }), b["aria-activedescendant"] = ge.isOpen && ge.highlightedIndex > -1 ? c.getItemId(ge.highlightedIndex) : "", b["aria-autocomplete"] = "list", b["aria-controls"] = c.menuId, b["aria-expanded"] = ge.isOpen, b["aria-labelledby"] = A && A["aria-label"] ? void 0 : c.labelId, b.autoComplete = "off", b.id = c.inputId, b.role = "combobox", b.value = ge.inputValue, b), Fe, A);
  }, [a, c, i, L, p, V, R]), Q = re(function() {
    a({
      type: Un
    });
  }, [a]), Z = re(function() {
    a({
      type: zn
    });
  }, [a]), ie = re(function() {
    a({
      type: qn
    });
  }, [a]), se = re(function(x) {
    a({
      type: Gn,
      highlightedIndex: x
    });
  }, [a]), le = re(function(x) {
    a({
      type: kt,
      selectedItem: x
    });
  }, [a]), _ = re(function(x) {
    a({
      type: Xn,
      inputValue: x
    });
  }, [a]), D = re(function() {
    a({
      type: Jn
    });
  }, [a]);
  return {
    // prop getters.
    getItemProps: W,
    getLabelProps: H,
    getMenuProps: j,
    getInputProps: T,
    getToggleButtonProps: J,
    // actions.
    toggleMenu: Q,
    openMenu: ie,
    closeMenu: Z,
    setHighlightedIndex: se,
    setInputValue: _,
    selectItem: le,
    reset: D,
    // state.
    highlightedIndex: d,
    isOpen: l,
    selectedItem: g,
    inputValue: v
  };
}
We.stateReducer, We.itemToKey, We.environment, I.array, I.array, I.array, I.func, I.number, I.number, I.number, I.func, I.func, I.string, I.string;
Te.itemToKey, Te.stateReducer, Te.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
function _e(e) {
  return Array.isArray ? Array.isArray(e) : nr(e) === "[object Array]";
}
function Do(e) {
  if (typeof e == "string")
    return e;
  let t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function So(e) {
  return e == null ? "" : Do(e);
}
function he(e) {
  return typeof e == "string";
}
function er(e) {
  return typeof e == "number";
}
function Ao(e) {
  return e === !0 || e === !1 || Mo(e) && nr(e) == "[object Boolean]";
}
function tr(e) {
  return typeof e == "object";
}
function Mo(e) {
  return tr(e) && e !== null;
}
function ae(e) {
  return e != null;
}
function ct(e) {
  return !e.trim().length;
}
function nr(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
const Ro = "Incorrect 'index' type", To = (e) => `Invalid value for key ${e}`, Po = (e) => `Pattern length exceeds max of ${e}.`, No = (e) => `Missing ${e} property in key`, Vo = (e) => `Property 'weight' in key '${e}' must be a positive integer`, dn = Object.prototype.hasOwnProperty;
class Fo {
  constructor(t) {
    this._keys = [], this._keyMap = {};
    let r = 0;
    t.forEach((o) => {
      let i = rr(o);
      this._keys.push(i), this._keyMap[i.id] = i, r += i.weight;
    }), this._keys.forEach((o) => {
      o.weight /= r;
    });
  }
  get(t) {
    return this._keyMap[t];
  }
  keys() {
    return this._keys;
  }
  toJSON() {
    return JSON.stringify(this._keys);
  }
}
function rr(e) {
  let t = null, r = null, o = null, i = 1, n = null;
  if (he(e) || _e(e))
    o = e, t = fn(e), r = mt(e);
  else {
    if (!dn.call(e, "name"))
      throw new Error(No("name"));
    const s = e.name;
    if (o = s, dn.call(e, "weight") && (i = e.weight, i <= 0))
      throw new Error(Vo(s));
    t = fn(s), r = mt(s), n = e.getFn;
  }
  return { path: t, id: r, weight: i, src: o, getFn: n };
}
function fn(e) {
  return _e(e) ? e : e.split(".");
}
function mt(e) {
  return _e(e) ? e.join(".") : e;
}
function ko(e, t) {
  let r = [], o = !1;
  const i = (n, s, u) => {
    if (ae(n))
      if (!s[u])
        r.push(n);
      else {
        let a = s[u];
        const l = n[a];
        if (!ae(l))
          return;
        if (u === s.length - 1 && (he(l) || er(l) || Ao(l)))
          r.push(So(l));
        else if (_e(l)) {
          o = !0;
          for (let d = 0, g = l.length; d < g; d += 1)
            i(l[d], s, u + 1);
        } else s.length && i(l, s, u + 1);
      }
  };
  return i(e, he(t) ? t.split(".") : t, 0), o ? r : r[0];
}
const $o = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: !1,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: !1,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
}, Bo = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: !1,
  // When `true`, the algorithm will ignore diacritics (accents) in comparisons
  ignoreDiacritics: !1,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: !1,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: !0,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (e, t) => e.score === t.score ? e.idx < t.idx ? -1 : 1 : e.score < t.score ? -1 : 1
}, Ho = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
}, Lo = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: !1,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: ko,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: !1,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: !1,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};
var B = {
  ...Bo,
  ...$o,
  ...Ho,
  ...Lo
};
const jo = /[^ ]+/g;
function Ko(e = 1, t = 3) {
  const r = /* @__PURE__ */ new Map(), o = Math.pow(10, t);
  return {
    get(i) {
      const n = i.match(jo).length;
      if (r.has(n))
        return r.get(n);
      const s = 1 / Math.pow(n, 0.5 * e), u = parseFloat(Math.round(s * o) / o);
      return r.set(n, u), u;
    },
    clear() {
      r.clear();
    }
  };
}
class Ht {
  constructor({
    getFn: t = B.getFn,
    fieldNormWeight: r = B.fieldNormWeight
  } = {}) {
    this.norm = Ko(r, 3), this.getFn = t, this.isCreated = !1, this.setIndexRecords();
  }
  setSources(t = []) {
    this.docs = t;
  }
  setIndexRecords(t = []) {
    this.records = t;
  }
  setKeys(t = []) {
    this.keys = t, this._keysMap = {}, t.forEach((r, o) => {
      this._keysMap[r.id] = o;
    });
  }
  create() {
    this.isCreated || !this.docs.length || (this.isCreated = !0, he(this.docs[0]) ? this.docs.forEach((t, r) => {
      this._addString(t, r);
    }) : this.docs.forEach((t, r) => {
      this._addObject(t, r);
    }), this.norm.clear());
  }
  // Adds a doc to the end of the index
  add(t) {
    const r = this.size();
    he(t) ? this._addString(t, r) : this._addObject(t, r);
  }
  // Removes the doc at the specified index of the index
  removeAt(t) {
    this.records.splice(t, 1);
    for (let r = t, o = this.size(); r < o; r += 1)
      this.records[r].i -= 1;
  }
  getValueForItemAtKeyId(t, r) {
    return t[this._keysMap[r]];
  }
  size() {
    return this.records.length;
  }
  _addString(t, r) {
    if (!ae(t) || ct(t))
      return;
    let o = {
      v: t,
      i: r,
      n: this.norm.get(t)
    };
    this.records.push(o);
  }
  _addObject(t, r) {
    let o = { i: r, $: {} };
    this.keys.forEach((i, n) => {
      let s = i.getFn ? i.getFn(t) : this.getFn(t, i.path);
      if (ae(s)) {
        if (_e(s)) {
          let u = [];
          const a = [{ nestedArrIndex: -1, value: s }];
          for (; a.length; ) {
            const { nestedArrIndex: l, value: d } = a.pop();
            if (ae(d))
              if (he(d) && !ct(d)) {
                let g = {
                  v: d,
                  i: l,
                  n: this.norm.get(d)
                };
                u.push(g);
              } else _e(d) && d.forEach((g, v) => {
                a.push({
                  nestedArrIndex: v,
                  value: g
                });
              });
          }
          o.$[n] = u;
        } else if (he(s) && !ct(s)) {
          let u = {
            v: s,
            n: this.norm.get(s)
          };
          o.$[n] = u;
        }
      }
    }), this.records.push(o);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    };
  }
}
function or(e, t, { getFn: r = B.getFn, fieldNormWeight: o = B.fieldNormWeight } = {}) {
  const i = new Ht({ getFn: r, fieldNormWeight: o });
  return i.setKeys(e.map(rr)), i.setSources(t), i.create(), i;
}
function Wo(e, { getFn: t = B.getFn, fieldNormWeight: r = B.fieldNormWeight } = {}) {
  const { keys: o, records: i } = e, n = new Ht({ getFn: t, fieldNormWeight: r });
  return n.setKeys(o), n.setIndexRecords(i), n;
}
function Le(e, {
  errors: t = 0,
  currentLocation: r = 0,
  expectedLocation: o = 0,
  distance: i = B.distance,
  ignoreLocation: n = B.ignoreLocation
} = {}) {
  const s = t / e.length;
  if (n)
    return s;
  const u = Math.abs(o - r);
  return i ? s + u / i : u ? 1 : s;
}
function Yo(e = [], t = B.minMatchCharLength) {
  let r = [], o = -1, i = -1, n = 0;
  for (let s = e.length; n < s; n += 1) {
    let u = e[n];
    u && o === -1 ? o = n : !u && o !== -1 && (i = n - 1, i - o + 1 >= t && r.push([o, i]), o = -1);
  }
  return e[n - 1] && n - o >= t && r.push([o, n - 1]), r;
}
const xe = 32;
function Uo(e, t, r, {
  location: o = B.location,
  distance: i = B.distance,
  threshold: n = B.threshold,
  findAllMatches: s = B.findAllMatches,
  minMatchCharLength: u = B.minMatchCharLength,
  includeMatches: a = B.includeMatches,
  ignoreLocation: l = B.ignoreLocation
} = {}) {
  if (t.length > xe)
    throw new Error(Po(xe));
  const d = t.length, g = e.length, v = Math.max(0, Math.min(o, g));
  let y = n, O = v;
  const E = u > 1 || a, m = E ? Array(g) : [];
  let F;
  for (; (F = e.indexOf(t, O)) > -1; ) {
    let V = Le(t, {
      currentLocation: F,
      expectedLocation: v,
      distance: i,
      ignoreLocation: l
    });
    if (y = Math.min(V, y), O = F + d, E) {
      let R = 0;
      for (; R < d; )
        m[F + R] = 1, R += 1;
    }
  }
  O = -1;
  let c = [], h = 1, p = d + g;
  const f = 1 << d - 1;
  for (let V = 0; V < d; V += 1) {
    let R = 0, L = p;
    for (; R < L; )
      Le(t, {
        errors: V,
        currentLocation: v + L,
        expectedLocation: v,
        distance: i,
        ignoreLocation: l
      }) <= y ? R = L : p = L, L = Math.floor((p - R) / 2 + R);
    p = L;
    let H = Math.max(1, v - L + 1), j = s ? g : Math.min(v + L, g) + d, W = Array(j + 2);
    W[j + 1] = (1 << V) - 1;
    for (let T = j; T >= H; T -= 1) {
      let Q = T - 1, Z = r[e.charAt(Q)];
      if (E && (m[Q] = +!!Z), W[T] = (W[T + 1] << 1 | 1) & Z, V && (W[T] |= (c[T + 1] | c[T]) << 1 | 1 | c[T + 1]), W[T] & f && (h = Le(t, {
        errors: V,
        currentLocation: Q,
        expectedLocation: v,
        distance: i,
        ignoreLocation: l
      }), h <= y)) {
        if (y = h, O = Q, O <= v)
          break;
        H = Math.max(1, 2 * v - O);
      }
    }
    if (Le(t, {
      errors: V + 1,
      currentLocation: v,
      expectedLocation: v,
      distance: i,
      ignoreLocation: l
    }) > y)
      break;
    c = W;
  }
  const M = {
    isMatch: O >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(1e-3, h)
  };
  if (E) {
    const V = Yo(m, u);
    V.length ? a && (M.indices = V) : M.isMatch = !1;
  }
  return M;
}
function qo(e) {
  let t = {};
  for (let r = 0, o = e.length; r < o; r += 1) {
    const i = e.charAt(r);
    t[i] = (t[i] || 0) | 1 << o - r - 1;
  }
  return t;
}
const Qe = String.prototype.normalize ? (e) => e.normalize("NFD").replace(/[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]/g, "") : (e) => e;
class ir {
  constructor(t, {
    location: r = B.location,
    threshold: o = B.threshold,
    distance: i = B.distance,
    includeMatches: n = B.includeMatches,
    findAllMatches: s = B.findAllMatches,
    minMatchCharLength: u = B.minMatchCharLength,
    isCaseSensitive: a = B.isCaseSensitive,
    ignoreDiacritics: l = B.ignoreDiacritics,
    ignoreLocation: d = B.ignoreLocation
  } = {}) {
    if (this.options = {
      location: r,
      threshold: o,
      distance: i,
      includeMatches: n,
      findAllMatches: s,
      minMatchCharLength: u,
      isCaseSensitive: a,
      ignoreDiacritics: l,
      ignoreLocation: d
    }, t = a ? t : t.toLowerCase(), t = l ? Qe(t) : t, this.pattern = t, this.chunks = [], !this.pattern.length)
      return;
    const g = (y, O) => {
      this.chunks.push({
        pattern: y,
        alphabet: qo(y),
        startIndex: O
      });
    }, v = this.pattern.length;
    if (v > xe) {
      let y = 0;
      const O = v % xe, E = v - O;
      for (; y < E; )
        g(this.pattern.substr(y, xe), y), y += xe;
      if (O) {
        const m = v - xe;
        g(this.pattern.substr(m), m);
      }
    } else
      g(this.pattern, 0);
  }
  searchIn(t) {
    const { isCaseSensitive: r, ignoreDiacritics: o, includeMatches: i } = this.options;
    if (t = r ? t : t.toLowerCase(), t = o ? Qe(t) : t, this.pattern === t) {
      let E = {
        isMatch: !0,
        score: 0
      };
      return i && (E.indices = [[0, t.length - 1]]), E;
    }
    const {
      location: n,
      distance: s,
      threshold: u,
      findAllMatches: a,
      minMatchCharLength: l,
      ignoreLocation: d
    } = this.options;
    let g = [], v = 0, y = !1;
    this.chunks.forEach(({ pattern: E, alphabet: m, startIndex: F }) => {
      const { isMatch: c, score: h, indices: p } = Uo(t, E, m, {
        location: n + F,
        distance: s,
        threshold: u,
        findAllMatches: a,
        minMatchCharLength: l,
        includeMatches: i,
        ignoreLocation: d
      });
      c && (y = !0), v += h, c && p && (g = [...g, ...p]);
    });
    let O = {
      isMatch: y,
      score: y ? v / this.chunks.length : 1
    };
    return y && i && (O.indices = g), O;
  }
}
class be {
  constructor(t) {
    this.pattern = t;
  }
  static isMultiMatch(t) {
    return pn(t, this.multiRegex);
  }
  static isSingleMatch(t) {
    return pn(t, this.singleRegex);
  }
  search() {
  }
}
function pn(e, t) {
  const r = e.match(t);
  return r ? r[1] : null;
}
class zo extends be {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "exact";
  }
  static get multiRegex() {
    return /^="(.*)"$/;
  }
  static get singleRegex() {
    return /^=(.*)$/;
  }
  search(t) {
    const r = t === this.pattern;
    return {
      isMatch: r,
      score: r ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class Go extends be {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "inverse-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"$/;
  }
  static get singleRegex() {
    return /^!(.*)$/;
  }
  search(t) {
    const o = t.indexOf(this.pattern) === -1;
    return {
      isMatch: o,
      score: o ? 0 : 1,
      indices: [0, t.length - 1]
    };
  }
}
class Xo extends be {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "prefix-exact";
  }
  static get multiRegex() {
    return /^\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^\^(.*)$/;
  }
  search(t) {
    const r = t.startsWith(this.pattern);
    return {
      isMatch: r,
      score: r ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class Jo extends be {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "inverse-prefix-exact";
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^!\^(.*)$/;
  }
  search(t) {
    const r = !t.startsWith(this.pattern);
    return {
      isMatch: r,
      score: r ? 0 : 1,
      indices: [0, t.length - 1]
    };
  }
}
class Qo extends be {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "suffix-exact";
  }
  static get multiRegex() {
    return /^"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^(.*)\$$/;
  }
  search(t) {
    const r = t.endsWith(this.pattern);
    return {
      isMatch: r,
      score: r ? 0 : 1,
      indices: [t.length - this.pattern.length, t.length - 1]
    };
  }
}
class Zo extends be {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "inverse-suffix-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^!(.*)\$$/;
  }
  search(t) {
    const r = !t.endsWith(this.pattern);
    return {
      isMatch: r,
      score: r ? 0 : 1,
      indices: [0, t.length - 1]
    };
  }
}
class sr extends be {
  constructor(t, {
    location: r = B.location,
    threshold: o = B.threshold,
    distance: i = B.distance,
    includeMatches: n = B.includeMatches,
    findAllMatches: s = B.findAllMatches,
    minMatchCharLength: u = B.minMatchCharLength,
    isCaseSensitive: a = B.isCaseSensitive,
    ignoreDiacritics: l = B.ignoreDiacritics,
    ignoreLocation: d = B.ignoreLocation
  } = {}) {
    super(t), this._bitapSearch = new ir(t, {
      location: r,
      threshold: o,
      distance: i,
      includeMatches: n,
      findAllMatches: s,
      minMatchCharLength: u,
      isCaseSensitive: a,
      ignoreDiacritics: l,
      ignoreLocation: d
    });
  }
  static get type() {
    return "fuzzy";
  }
  static get multiRegex() {
    return /^"(.*)"$/;
  }
  static get singleRegex() {
    return /^(.*)$/;
  }
  search(t) {
    return this._bitapSearch.searchIn(t);
  }
}
class ur extends be {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "include";
  }
  static get multiRegex() {
    return /^'"(.*)"$/;
  }
  static get singleRegex() {
    return /^'(.*)$/;
  }
  search(t) {
    let r = 0, o;
    const i = [], n = this.pattern.length;
    for (; (o = t.indexOf(this.pattern, r)) > -1; )
      r = o + n, i.push([o, r - 1]);
    const s = !!i.length;
    return {
      isMatch: s,
      score: s ? 0 : 1,
      indices: i
    };
  }
}
const vt = [
  zo,
  ur,
  Xo,
  Jo,
  Zo,
  Qo,
  Go,
  sr
], hn = vt.length, ei = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/, ti = "|";
function ni(e, t = {}) {
  return e.split(ti).map((r) => {
    let o = r.trim().split(ei).filter((n) => n && !!n.trim()), i = [];
    for (let n = 0, s = o.length; n < s; n += 1) {
      const u = o[n];
      let a = !1, l = -1;
      for (; !a && ++l < hn; ) {
        const d = vt[l];
        let g = d.isMultiMatch(u);
        g && (i.push(new d(g, t)), a = !0);
      }
      if (!a)
        for (l = -1; ++l < hn; ) {
          const d = vt[l];
          let g = d.isSingleMatch(u);
          if (g) {
            i.push(new d(g, t));
            break;
          }
        }
    }
    return i;
  });
}
const ri = /* @__PURE__ */ new Set([sr.type, ur.type]);
class oi {
  constructor(t, {
    isCaseSensitive: r = B.isCaseSensitive,
    ignoreDiacritics: o = B.ignoreDiacritics,
    includeMatches: i = B.includeMatches,
    minMatchCharLength: n = B.minMatchCharLength,
    ignoreLocation: s = B.ignoreLocation,
    findAllMatches: u = B.findAllMatches,
    location: a = B.location,
    threshold: l = B.threshold,
    distance: d = B.distance
  } = {}) {
    this.query = null, this.options = {
      isCaseSensitive: r,
      ignoreDiacritics: o,
      includeMatches: i,
      minMatchCharLength: n,
      findAllMatches: u,
      ignoreLocation: s,
      location: a,
      threshold: l,
      distance: d
    }, t = r ? t : t.toLowerCase(), t = o ? Qe(t) : t, this.pattern = t, this.query = ni(this.pattern, this.options);
  }
  static condition(t, r) {
    return r.useExtendedSearch;
  }
  searchIn(t) {
    const r = this.query;
    if (!r)
      return {
        isMatch: !1,
        score: 1
      };
    const { includeMatches: o, isCaseSensitive: i, ignoreDiacritics: n } = this.options;
    t = i ? t : t.toLowerCase(), t = n ? Qe(t) : t;
    let s = 0, u = [], a = 0;
    for (let l = 0, d = r.length; l < d; l += 1) {
      const g = r[l];
      u.length = 0, s = 0;
      for (let v = 0, y = g.length; v < y; v += 1) {
        const O = g[v], { isMatch: E, indices: m, score: F } = O.search(t);
        if (E) {
          if (s += 1, a += F, o) {
            const c = O.constructor.type;
            ri.has(c) ? u = [...u, ...m] : u.push(m);
          }
        } else {
          a = 0, s = 0, u.length = 0;
          break;
        }
      }
      if (s) {
        let v = {
          isMatch: !0,
          score: a / s
        };
        return o && (v.indices = u), v;
      }
    }
    return {
      isMatch: !1,
      score: 1
    };
  }
}
const _t = [];
function ii(...e) {
  _t.push(...e);
}
function yt(e, t) {
  for (let r = 0, o = _t.length; r < o; r += 1) {
    let i = _t[r];
    if (i.condition(e, t))
      return new i(e, t);
  }
  return new ir(e, t);
}
const Ze = {
  AND: "$and",
  OR: "$or"
}, It = {
  PATH: "$path",
  PATTERN: "$val"
}, Et = (e) => !!(e[Ze.AND] || e[Ze.OR]), si = (e) => !!e[It.PATH], ui = (e) => !_e(e) && tr(e) && !Et(e), gn = (e) => ({
  [Ze.AND]: Object.keys(e).map((t) => ({
    [t]: e[t]
  }))
});
function ar(e, t, { auto: r = !0 } = {}) {
  const o = (i) => {
    let n = Object.keys(i);
    const s = si(i);
    if (!s && n.length > 1 && !Et(i))
      return o(gn(i));
    if (ui(i)) {
      const a = s ? i[It.PATH] : n[0], l = s ? i[It.PATTERN] : i[a];
      if (!he(l))
        throw new Error(To(a));
      const d = {
        keyId: mt(a),
        pattern: l
      };
      return r && (d.searcher = yt(l, t)), d;
    }
    let u = {
      children: [],
      operator: n[0]
    };
    return n.forEach((a) => {
      const l = i[a];
      _e(l) && l.forEach((d) => {
        u.children.push(o(d));
      });
    }), u;
  };
  return Et(e) || (e = gn(e)), o(e);
}
function ai(e, { ignoreFieldNorm: t = B.ignoreFieldNorm }) {
  e.forEach((r) => {
    let o = 1;
    r.matches.forEach(({ key: i, norm: n, score: s }) => {
      const u = i ? i.weight : null;
      o *= Math.pow(
        s === 0 && u ? Number.EPSILON : s,
        (u || 1) * (t ? 1 : n)
      );
    }), r.score = o;
  });
}
function ci(e, t) {
  const r = e.matches;
  t.matches = [], ae(r) && r.forEach((o) => {
    if (!ae(o.indices) || !o.indices.length)
      return;
    const { indices: i, value: n } = o;
    let s = {
      indices: i,
      value: n
    };
    o.key && (s.key = o.key.src), o.idx > -1 && (s.refIndex = o.idx), t.matches.push(s);
  });
}
function li(e, t) {
  t.score = e.score;
}
function di(e, t, {
  includeMatches: r = B.includeMatches,
  includeScore: o = B.includeScore
} = {}) {
  const i = [];
  return r && i.push(ci), o && i.push(li), e.map((n) => {
    const { idx: s } = n, u = {
      item: t[s],
      refIndex: s
    };
    return i.length && i.forEach((a) => {
      a(n, u);
    }), u;
  });
}
class Me {
  constructor(t, r = {}, o) {
    this.options = { ...B, ...r }, this.options.useExtendedSearch, this._keyStore = new Fo(this.options.keys), this.setCollection(t, o);
  }
  setCollection(t, r) {
    if (this._docs = t, r && !(r instanceof Ht))
      throw new Error(Ro);
    this._myIndex = r || or(this.options.keys, this._docs, {
      getFn: this.options.getFn,
      fieldNormWeight: this.options.fieldNormWeight
    });
  }
  add(t) {
    ae(t) && (this._docs.push(t), this._myIndex.add(t));
  }
  remove(t = () => !1) {
    const r = [];
    for (let o = 0, i = this._docs.length; o < i; o += 1) {
      const n = this._docs[o];
      t(n, o) && (this.removeAt(o), o -= 1, i -= 1, r.push(n));
    }
    return r;
  }
  removeAt(t) {
    this._docs.splice(t, 1), this._myIndex.removeAt(t);
  }
  getIndex() {
    return this._myIndex;
  }
  search(t, { limit: r = -1 } = {}) {
    const {
      includeMatches: o,
      includeScore: i,
      shouldSort: n,
      sortFn: s,
      ignoreFieldNorm: u
    } = this.options;
    let a = he(t) ? he(this._docs[0]) ? this._searchStringList(t) : this._searchObjectList(t) : this._searchLogical(t);
    return ai(a, { ignoreFieldNorm: u }), n && a.sort(s), er(r) && r > -1 && (a = a.slice(0, r)), di(a, this._docs, {
      includeMatches: o,
      includeScore: i
    });
  }
  _searchStringList(t) {
    const r = yt(t, this.options), { records: o } = this._myIndex, i = [];
    return o.forEach(({ v: n, i: s, n: u }) => {
      if (!ae(n))
        return;
      const { isMatch: a, score: l, indices: d } = r.searchIn(n);
      a && i.push({
        item: n,
        idx: s,
        matches: [{ score: l, value: n, norm: u, indices: d }]
      });
    }), i;
  }
  _searchLogical(t) {
    const r = ar(t, this.options), o = (u, a, l) => {
      if (!u.children) {
        const { keyId: g, searcher: v } = u, y = this._findMatches({
          key: this._keyStore.get(g),
          value: this._myIndex.getValueForItemAtKeyId(a, g),
          searcher: v
        });
        return y && y.length ? [
          {
            idx: l,
            item: a,
            matches: y
          }
        ] : [];
      }
      const d = [];
      for (let g = 0, v = u.children.length; g < v; g += 1) {
        const y = u.children[g], O = o(y, a, l);
        if (O.length)
          d.push(...O);
        else if (u.operator === Ze.AND)
          return [];
      }
      return d;
    }, i = this._myIndex.records, n = {}, s = [];
    return i.forEach(({ $: u, i: a }) => {
      if (ae(u)) {
        let l = o(r, u, a);
        l.length && (n[a] || (n[a] = { idx: a, item: u, matches: [] }, s.push(n[a])), l.forEach(({ matches: d }) => {
          n[a].matches.push(...d);
        }));
      }
    }), s;
  }
  _searchObjectList(t) {
    const r = yt(t, this.options), { keys: o, records: i } = this._myIndex, n = [];
    return i.forEach(({ $: s, i: u }) => {
      if (!ae(s))
        return;
      let a = [];
      o.forEach((l, d) => {
        a.push(
          ...this._findMatches({
            key: l,
            value: s[d],
            searcher: r
          })
        );
      }), a.length && n.push({
        idx: u,
        item: s,
        matches: a
      });
    }), n;
  }
  _findMatches({ key: t, value: r, searcher: o }) {
    if (!ae(r))
      return [];
    let i = [];
    if (_e(r))
      r.forEach(({ v: n, i: s, n: u }) => {
        if (!ae(n))
          return;
        const { isMatch: a, score: l, indices: d } = o.searchIn(n);
        a && i.push({
          score: l,
          key: t,
          value: n,
          idx: s,
          norm: u,
          indices: d
        });
      });
    else {
      const { v: n, n: s } = r, { isMatch: u, score: a, indices: l } = o.searchIn(n);
      u && i.push({ score: a, key: t, value: n, norm: s, indices: l });
    }
    return i;
  }
}
Me.version = "7.1.0";
Me.createIndex = or;
Me.parseIndex = Wo;
Me.config = B;
Me.parseQuery = ar;
ii(oi);
const fi = ({
  placeholder: e = "Search...",
  options: t,
  onSelectedItemChange: r,
  onIsOpenChange: o,
  emptyMessage: i,
  selectedValue: n,
  testId: s = "combobox-filter",
  keys: u = ["label"],
  // Perform fuzzy search on the 'label' key
  threshold: a = 0.3
  // Lower values mean stricter matches
}) => {
  const [l, d] = Ye.useState(t), g = Ye.useMemo(() => new Me(t, {
    keys: u,
    threshold: a
  }), [t, u, a]), {
    getMenuProps: v,
    getInputProps: y,
    getItemProps: O,
    highlightedIndex: E,
    setInputValue: m,
    selectItem: F
  } = Bt({
    items: l,
    itemToString: (c) => c ? c.label : "",
    onSelectedItemChange: r,
    onIsOpenChange: o,
    onInputValueChange: ({
      inputValue: c
    }) => {
      const h = c ? g.search(c).map((p) => p.item) : t;
      d(h);
    }
  });
  return /* @__PURE__ */ ee.jsxs("div", { children: [
    /* @__PURE__ */ ee.jsx(_r, { prefix: /* @__PURE__ */ ee.jsx(Ir, {}), fullWidth: !0, testId: s ? `${s}-input` : void 0, placeholder: e, className: "tw-border-0 tw-border-b tw-border-b-gray-900 focus:tw-outline-0 tw-rounded-bl-0 tw-rounded-br-0", onChange: (c) => m(c.target.value), ...y() }),
    /* @__PURE__ */ ee.jsx("ul", { ...v(), className: "tw-overflow-y-auto tw-bg-base-white tw-rounded-4 tw-rounded-tl-0 tw-rounded-tr-0", style: {
      maxHeight: "240px"
    }, children: l?.length ? (l || []).map((c, h) => /* @__PURE__ */ ee.jsxs("li", { ...O({
      index: h,
      item: c,
      className: Se("tw-flex tw-items-center tw-p-8 tw-gap-8 tw-cursor-pointer", {
        "tw-bg-gray-300": E === h
      }),
      // Fire selection on mousedown so it runs before the input blurs.
      onMouseDown: () => F(c)
    }), children: [
      /* @__PURE__ */ ee.jsx(yr, { className: Se(n === c.value ? "tw-opacity-100" : "tw-opacity-0") }),
      c.label
    ] }, `${c.value}_${h}`)) : /* @__PURE__ */ ee.jsx("li", { className: "tw-p-8 tw-text-gray-500", children: i || "No options found." }) })
  ] });
}, Lt = Ye.forwardRef(({
  errorMsg: e,
  fullWidth: t,
  readOnly: r,
  disabled: o,
  value: i,
  className: n,
  children: s,
  testId: u = "combobox-trigger",
  ...a
}, l) => /* @__PURE__ */ ee.jsx(Er, { ref: l, testId: u, suffix: /* @__PURE__ */ ee.jsx(br, { className: Se({
  "tw-text-gray-900": !o
}) }), fullWidth: t, disabled: o, variant: "outline-1", appearance: "white", value: i, ...a, className: Se("[&>span]:tw-inline-flex [&>span]:tw-justify-between [&>span]:tw-flex-1 tw-body-2 hover:tw-bg-base-white", {
  "tw-pointer-events-none": r,
  "tw-text-gray-600": !i && !o,
  "tw-border-red-800": !!e
}, n), children: s }));
Lt.displayName = "ComboboxTrigger";
const pi = ({
  options: e,
  renderTrigger: t,
  emptyMessage: r = "No options found.",
  fullWidth: o,
  disabled: i,
  value: n,
  readOnly: s,
  onValueChange: u,
  triggerProps: a,
  filterProps: l,
  contentProps: d,
  testId: g = "combobox"
}) => {
  const [v, y] = Ye.useState(!1), O = (e || []).find((E) => E.value === n);
  return /* @__PURE__ */ ee.jsxs(hr, { open: v, onOpenChange: y, children: [
    /* @__PURE__ */ ee.jsx(gr, { asChild: !0, role: "combobox", "aria-expanded": v, children: t ? t(O) : /* @__PURE__ */ ee.jsx(Lt, { testId: g ? `${g}-trigger` : void 0, fullWidth: o, disabled: i, value: n, readOnly: s, ...a || {}, children: O?.label || a?.placeholder }) }),
    /* @__PURE__ */ ee.jsx(mr, { ...d || {}, className: Se("tw-min-w-[200px] tw-w-[--radix-popover-trigger-width] tw-p-0 tw-relative tw-z-max", d?.className), children: /* @__PURE__ */ ee.jsx(fi, { emptyMessage: r, testId: g ? `${g}-filter` : void 0, options: e, selectedValue: n, onSelectedItemChange: ({
      selectedItem: E
    }) => {
      u?.(E ? E.value : null), y(!1);
    }, ...l || {}, onIsOpenChange: ({
      isOpen: E,
      ...m
    }) => {
      y(E), l?.onIsOpenChange?.({
        isOpen: E,
        ...m
      });
    } }) })
  ] });
}, Di = ({
  name: e,
  label: t,
  subcopy: r,
  note: o,
  options: i,
  renderTrigger: n,
  disabled: s,
  fullWidth: u,
  readOnly: a,
  emptyMessage: l = "No options found.",
  triggerProps: d,
  filterProps: g,
  contentProps: v,
  testId: y,
  required: O,
  forwardErrorMsg: E = !1
}) => {
  const {
    control: m
  } = wr();
  return /* @__PURE__ */ ee.jsx(Cr, { control: m, name: e, render: ({
    field: F
  }) => /* @__PURE__ */ ee.jsxs(xr, { className: "tw-flex tw-flex-col", disabled: s, children: [
    !!t && /* @__PURE__ */ ee.jsx(Or, { className: Se({
      "tw-pointer-events-none": a || s
    }), subcopy: r, required: O, children: t }),
    /* @__PURE__ */ ee.jsx(pi, { testId: y, options: i, value: F.value, onValueChange: F.onChange, renderTrigger: (c) => n ? /* @__PURE__ */ ee.jsx(Kt, { forwardErrorMsg: E, children: n(c, F) }) : /* @__PURE__ */ ee.jsx(Kt, { forwardErrorMsg: !0, children: /* @__PURE__ */ ee.jsx(Lt, { ref: F.ref, fullWidth: u, readOnly: a, disabled: s, value: F.value, testId: y ? `${y}-trigger` : void 0, ...d || {}, children: c?.label || d?.placeholder }) }), emptyMessage: l, disabled: s, filterProps: g, contentProps: v }),
    /* @__PURE__ */ ee.jsx(Dr, { children: o })
  ] }) });
};
export {
  pi as Combobox,
  Di as ComboboxField
};
//# sourceMappingURL=index.js.map
